/**
 * Class Loader
 *
 * @author Jeremie Nogues
 * @year 2024
 * @filename loader.js
 * @location /js/my
 */

import $ from "jquery";
import AppContext from "./appContext";
import Commons from "./commons";
import Dialog from "./dialog";
import Menu from "./menu";
import Ratchet from "./ratchet";
export default class Loader {
	constructor() {

		//classes globales
		window.$ = $;

		//register les classes
		const appContext = new AppContext();
		appContext.register("objDialog", new Dialog());
		appContext.register("objRatchet", new Ratchet());
		appContext.register("objCommons", new Commons(appContext));
		appContext.register("objMenu", new Menu(appContext));

		//création des objets
		this.appContext = appContext;
		this.objDialog = this.appContext.get("objDialog");
		this.objRatchet = this.appContext.get("objRatchet");
		this.objCommons = this.appContext.get("objCommons");
		this.objMenu = this.appContext.get("objMenu");

		//vérifie le navigateur 
		this.objCommons.checkNavigator();

		//entete CSRF pour AJAX
		if (php_to_js_vars.csrf && php_to_js_vars.csrf.hash && php_to_js_vars.csrf.header) {
			$.ajaxSetup({
				beforeSend: (xhr) => {
					xhr.setRequestHeader(php_to_js_vars.csrf.header, php_to_js_vars.csrf.hash);
				}
			});
		}

		//si c'est une page connectée
		if (php_to_js_vars.statut) {

			//vérifie que la session existe toujours
			$(document).ajaxComplete((event, xhr) => {

				//si la session a expiré
				if (xhr.status === 401) {

					//sur quel page de connexion faut-il renvoyer
					let redirect = "";
					switch (php_to_js_vars.statut) {
						case "eleve":
						case "etudiant":
							redirect = "eleve";
							break;
						case "patient":
							redirect = "patient";
							break;
						default:
							redirect = "utilisateur";
							break;
					}

					//on redirige vers la page de connexion
					location.href = php_to_js_vars.url + "connexion/" + redirect;
				}
			});
		}

		//génère les tooltips pour tous les élèments ayant un "tooltip-content"
		document.querySelectorAll("[tooltip-content]").forEach(element => {
			this.objCommons.createTooltip(element);
		});

		//lance la fonction de la page correspondante si elle existe
		(async () => {
			if (typeof this[js_page_name] === "function") {
				await this[js_page_name]();

				//démarre le websocket
				this.objRatchet.initSocketListeners(this.appContext);
			}
		})();
	}
	/**
	 * Page de gestion des actualités
	 */
	async actualitesGerer() {

		//importe les modules
		const [{default: Actualite}] = await Promise.all([
			import("./actualite")
		]);

		//nouvel objet
		const objActualite = new Actualite(this.appContext);

		//ouvre le dialog de création d'une actu
		this.objCommons.bindEvent("bouton_creer_actualite", "click", () => objActualite.openDialog());

		//boucle pour chaque actualité de la page
		document.querySelectorAll("#tableau_actualites tbody tr").forEach(actualite => {
			if (actualite.hasAttribute('id')) {
				const _k = actualite.id.split("_")[1];

				//met a jour la visibilité d'une actu
				this.objCommons.bindEvent("checkbox_" + _k, "change", (event) => {
					objActualite.visibilite(_k, event.currentTarget.checked);
				});

				//ouvre le dialog de modification d'une actu
				this.objCommons.bindEvent("modifier_" + _k, "click", () => objActualite.openDialog(_k));

				//supprime une actu
				this.objCommons.bindEvent("supprimer_" + _k, "click", () => objActualite.dialogDelete(_k));
			}
		});

		//rend le tableau des actualités triable par colonnes
		this.objCommons.sortTable(document.getElementById("tableau_actualites"));
	}
	/**
	 * Page avec les données sur les connexions
	 */
	async analyticsVoir() {

		//importe les modules
		const [{default: Graphiques}] = await Promise.all([
			import("./graphiques")
		]);

		//nouvel objet
		const objGraphiques = new Graphiques(this.appContext);

		//génère le graphique visiteurs
		objGraphiques.visiteurs();
	}
	/**
	 * Page de précalibration
	 */
	async calibrationsPrecalibration() {

		//importe les modules
		const [{default: Calibration}, {default: Exercices}] = await Promise.all([
			import("./calibration"),
			import("./exercices")
		]);

		//register les classes
		this.appContext.register("objCalibration", new Calibration(this.appContext));
		this.appContext.register("objExercices", new Exercices(this.appContext));

		//création des objets
		const objCalibration = this.appContext.get("objCalibration");

		//initialise le menu
		this.objMenu.groupes();

		//valide l'exercice
		this.objCommons.bindEvent("bouton_valider_exercice", "click", (event) => {
			this.objCommons.disableButton(event.currentTarget.id);
			objCalibration.preCalibration("valider");
		});

		//ne valide pas l'exercice
		this.objCommons.bindEvent("bouton_pas_valider_exercice", "click", () => {
			this.objCommons.setDisplay("div_reponse", "none");
			this.objCommons.setDisplay("div_select", "flex");
		});

		//choisi une raison
		this.objCommons.bindEvent("bouton_valider", "click", () => objCalibration.preCalibration("pas_valider"));

		//retourne au choix
		this.objCommons.bindEvent("bouton_annuler", "click", () => {
			this.objCommons.setDisplay("div_reponse", "flex");
			this.objCommons.setDisplay("div_select", "none");
		});
	}
	/**
	 * Page des séances de calibration
	 */
	async calibrationsSeance() {

		//importe les modules
		const [{default: EleveParametres}, {default: Calibration}, {default: Tchat}] = await Promise.all([
			import("./eleveParametres"),
			import("./calibration"),
			import("./tchat")
		]);

		//register les classes
		this.appContext.register("objCalibration", new Calibration(this.appContext));
		this.appContext.register("objTchat", new Tchat(this.appContext));

		//création des objets
		const objCalibration = this.appContext.get("objCalibration");
		const objEleveParametres = new EleveParametres(this.appContext);

		//initialise le menu
		this.objMenu.groupes();

		//action sur le slider
		this.objCommons.bindEvent("slider_statut_calibration", "change", (event) => {
			if (event.currentTarget.checked) {
				objCalibration.update("statut", "ouvert");
			} else {
				objCalibration.update("statut", "ferme");
			}
		});

		//rend le tableau sortable
		this.objCommons.sortTable(document.querySelector(".table_calibration_detail"));

		//boucle pour chaque élève
		document.querySelectorAll(".table_calibration_detail tbody>tr").forEach(eleve => {

			//paramètres élèves
			const icone_parametres = eleve.querySelector('[name="parametres_eleve"]');
			icone_parametres.addEventListener("click", () => {

				//récupère le nom de l'élève
				let nom_eleve_propre = "";
				const nom_eleve = eleve.querySelector(".nom_eleve");
				if (nom_eleve) {

					//conserve que le nom / prénom de l'élève
					nom_eleve_propre = nom_eleve.innerHTML.split("<")[0].trim();
				}

				objEleveParametres.parametres(eleve.dataset.id, nom_eleve_propre);
			});
		});

		//refresh le statut de la calibration
		objCalibration.refreshCalibrations();
	}
	/**
	 * Page pour la création des élèves d'une classe
	 */
	async classesCreateEleves() {

		//importe les modules
		const [{default: Eleves}] = await Promise.all([
			import("./eleves")
		]);

		//nouvel objet
		const objEleves = new Eleves(this.appContext);

		//initialise le menu
		this.objMenu.classes();

		//ajoute 5 lignes dans le tableau
		for (let i = 0; i < 5; i++) {
			objEleves.newLineEleve(true);
		}

		//ajoute une ligne nouvel eleve
		this.objCommons.bindEvent("bouton_ajouter_ligne", "click", () => objEleves.newLineEleve(true));

		//ouvre le dialog d'importation des élèves
		this.objCommons.bindEvent("bouton_import_csv", "click", () => objEleves.dialogImport());

		//valide la création d'élèves
		this.objCommons.bindEvent("valider", "click", () => objEleves.dialogCreateEleve());

		//annule
		this.objCommons.bindEvent("annuler", "click", () => {
			const currentURL = location.href;
			location.href = currentURL.replace("createEleves", "eleves");
		});

		//detecte changement de page
		window.addEventListener("beforeunload", (event) => {

			//si c'est pas une redirection après l'envoi du formulaire
			if (objEleves.checkReload === null) {

				//boucle pour chaque formulaire de la page
				let compteur = 0;
				document.querySelectorAll("#liste_nouveaux_eleves tbody tr").forEach(ligne => {
					const _k = ligne.id.split("_")[2];
					if (document.getElementById("nom_eleve_" + _k).value !== "" || document.getElementById("prenom_eleve_" + _k).value !== "") {
						compteur++;
					}
				});

				//si un élève est en cours de modif/création
				if (compteur !== 0) {
					event.preventDefault();
					event.returnValue = "";
				} else {
					return "";
				}
			}
		});
	}
	/**
	 * Page avec la liste des élèves d'une classe
	 */
	async classesEleves() {

		//importe les modules
		const [{default: Eleves}] = await Promise.all([
			import("./eleves")
		]);

		//nouvel objet
		const objEleves = new Eleves(this.appContext);

		//initialise le menu
		this.objMenu.classes();

		//renvoie sur la page de création d'élèves
		this.objCommons.bindEvent("bouton_creer_eleve", "click", (event) => {
			this.objCommons.disableButton(event.currentTarget.id);
			const currentURL = location.href;
			location.href = currentURL.replace("eleves", "createEleves");
		});

		//télécharge la liste des élèves en csv
		this.objCommons.bindEvent("bouton_export_csv", "click", () => {
			window.open("../exporter");
		});

		//affiche le fichier parent
		this.objCommons.bindEvent("bouton_cartes_pdf", "click", () => {
			window.open("../../documents/cartesPdf/classe");
		});

		//récupère les élèves
		const eleves = document.querySelectorAll("#tableau_eleves tbody tr[data-eleve]");

		//si aucun élève
		if (eleves.length === 0) {

			//affiche le dialog de consentement
			objEleves.consentement();
		} else {
			eleves.forEach(tr => {
				const _k = tr.getAttribute("data-eleve");

				//réinitialise un pass
				this.objCommons.bindEvent("reset_pass_" + _k, "click", () => objEleves.resetPass(_k));

				//changement de classe
				this.objCommons.bindEvent("changer_classe_" + _k, "click", () => objEleves.dialogChangerClasse(_k));

				//modifie un élève
				this.objCommons.bindEvent("modifier_" + _k, "click", () => objEleves.dialogUpdate(_k));

				//supprime un élève
				this.objCommons.bindEvent("supprimer_" + _k, "click", () => objEleves.dialogDelete(_k));

				//désactive un élève
				this.objCommons.bindEvent("desactiver_" + _k, "click", () => objEleves.dialogDesactiver(_k));

				//réactive un élève
				this.objCommons.bindEvent("reactiver_" + _k, "click", () => objEleves.reactiverEleve(_k));
			});

			//rend le tableau triable par colonne
			this.objCommons.sortTable(document.getElementById("tableau_eleves"));
		}
	}
	/**
	 * Page avec la liste des classes
	 */
	async classesListe() {

		//importe les modules
		const [{default: Classes}] = await Promise.all([
			import("./classes")
		]);

		//nouvel objet
		const objClasses = new Classes(this.appContext);

		//creation d'une classe
		this.objCommons.bindEvent("bouton_creer_classe", "click", () => objClasses.openDialog());

		//boucle pour chaque classe de la page
		document.querySelectorAll("#tableau_classes tbody tr").forEach(classe => {
			if (classe.hasAttribute("id")) {
				const _k = classe.id.split("_")[1];

				//renvoie sur la page de gestion des élèves
				this.objCommons.bindEvent("eleves_" + _k, "click", () => {
					location.href = "eleves/" + _k;
				});

				//renvoie sur la page d'affichage des résultats
				this.objCommons.bindEvent("resultats_" + _k, "click", () => {
					location.href = "../resultats/voir/" + _k + "/1";
				});

				//modifie une classe
				this.objCommons.bindEvent("modifier_" + _k, "click", () => objClasses.openDialog(_k));

				//supprime une classe
				this.objCommons.bindEvent("supprimer_" + _k, "click", () => objClasses.dialogDelete(_k));
			}
		});

		//rend le tableau triable par colonne
		this.objCommons.sortTable(document.getElementById("tableau_classes"));
	}
	/**
	 * Page avec la liste des abonnements GAR d'un établissement
	 */
	async comptesAboGar() {

		//importe les modules
		const [{default: Gar}] = await Promise.all([
			import("./gar")
		]);

		//nouvel objet
		const objGar = new Gar(this.appContext);

		//initialise le menu
		this.objMenu.comptes();

		//suppression des abonnements
		this.objCommons.bindEvent("bouton_delete_abonnement", "click", () => objGar.dialogDeleteAboGar());
	}
	/**
	 * Page avec la liste des enseignants d'un établissement
	 */
	async comptesDossier() {

		//importe les modules
		const [{default: Commandes}, {default: Comptes}, {default: Utilisateur}] = await Promise.all([
			import("./commandes"),
			import("./comptes"),
			import("./utilisateur")
		]);

		//nouvel objet
		const objCommandes = new Commandes(this.appContext);
		const objComptes = new Comptes(this.appContext);
		const objUtilisateur = new Utilisateur(this.appContext);

		//initialise le menu
		this.objMenu.comptes();

		//met à jour l'adresse mail
		this.objCommons.bindEvent("email", "focusout", (event) => {
			objComptes.updateEmail(event.currentTarget.innerText.trim());
		});

		//renvoyer les identifiants
		this.objCommons.bindEvent("identifiants", "click", () => objUtilisateur.sendIdentifiants());

		//ajouter une licence
		this.objCommons.bindEvent("ajout_licence", "click", () => objComptes.ajouterLicence());

		//affiche le formulaire de nouvelle commande
		this.objCommons.bindEvent("bouton_nouvelle_commande", "click", (event) => {
			this.objCommons.disableButton(event.currentTarget.id);
			location.href = "../commander";
		});

		//boucle pour chaque comande
		document.querySelectorAll("#tableau_licence tbody>tr").forEach(commande => {
			const id_commande = commande.id.split("_")[1];

			//récupère le bdc
			const icone_bdc = commande.querySelector('.icone-document');
			if (icone_bdc) {
				icone_bdc.addEventListener("click", () => window.open("../bonDeCommande/" + id_commande));
			}

			//récupère la facture
			const icone_facture = commande.querySelector('.icone-pdf');
			if (icone_facture) {
				icone_facture.addEventListener("click", () => window.open("../facture/" + id_commande));
			}

			//modifie la commande
			const icone_edit = commande.querySelector('.icone-edit');
			if (icone_edit) {
				icone_edit.addEventListener("click", () => location.href = "../modifierCommande/" + id_commande);
			}

			//annule la commande
			const icone_trash = commande.querySelector(".icone-trash");
			if (icone_trash) {
				icone_trash.addEventListener("click", () => objCommandes.dialogCancel(id_commande));
			}
		});
	}
	/**
	 * Page avec la liste des comptes
	 */
	async comptesListe() {

		//importe les modules
		const [{default: Comptes}] = await Promise.all([
			import("./comptes")
		]);

		//nouvel objet
		const objComptes = new Comptes(this.appContext);

		//initialise le menu
		this.objMenu.comptes();

		//filtre les etablissements en fonction du type
		this.objCommons.bindEvent("filtre_etablissements", "change", (event) => {
			let _url = "../" + event.currentTarget.value + "/1";
			const _search_value = document.getElementById("search").value;
			if (_search_value !== "") {
				_url += "?search=" + _search_value;
			}
			location.href = _url;
		});

		//renvoie a la page sélectionnée
		this.objCommons.bindEvent("num_page", "change", (event) => {
			let _url = "../" + document.getElementById("filtre_etablissements").value + "/" + event.currentTarget.value;
			const _search_value = document.getElementById("search").value;
			if (_search_value !== "") {
				_url += "?search=" + _search_value;
			}
			location.href = _url;
		});

		//dialog de création d'un compte
		if (document.getElementById("bouton_creer_compte")) {
			const id_dialog = "dialog_creer_compte";

			//bouton de création
			this.objCommons.bindEvent("bouton_creer_compte", "click", () => {
				this.objDialog.setId(id_dialog);
				this.objDialog.show();
			});

			//action sur le bouton de validation
			this.objCommons.bindEvent(id_dialog + "_valider", "click", () => objComptes.create());

			//action sur le bouton d'annulation
			this.objCommons.bindEvent(id_dialog + "_annuler", "click", () => this.objDialog.hide());
		}

		//lance une recherche
		this.objCommons.bindEvent("search", "keypress", (event) => {

			//appuie sur "enter"
			if (event.keyCode === 13) {
				const _search_value = event.currentTarget.value;
				if (_search_value !== "") {
					location.href = "?search=" + _search_value;
				}
				return false;
			}
		});

		//lance une recherche
		this.objCommons.bindEvent("bouton_search", "click", () => {
			const _search_value = document.getElementById("search").value;
			if (_search_value !== "") {
				location.href = "?search=" + _search_value;
			}
		});

		//annule une recherche
		this.objCommons.bindEvent("bouton_cancel_search", "click", () => {
			location.href = "1";
		});

		//rend le tableau triable par colonne
		this.objCommons.sortTable(document.getElementById("tableau_comptes"));

		//action sur le sablier
		document.querySelectorAll("#tableau_comptes .icone-sablier").forEach(div => {
			const id = div.dataset.id;
			div.addEventListener("click", () => objComptes.dialogValidationOrtho(id));
		});
	}
	/**
	 * Page de validation du compte
	 */
	async comptesValideInscription() {

		//initialise le menu
		this.objMenu.comptes();
	}
	/**
	 * Page de résumé des comptes
	 */
	async comptesResume() {

		//importe les modules
		const [{default: Carte}, {default: Graphiques}] = await Promise.all([
			import("./carte"),
			import("./graphiques")
		]);

		//nouvel objet
		const objCarte = new Carte(this.appContext);
		const objGraphiques = new Graphiques(this.appContext);

		//initialise le menu
		this.objMenu.comptes();

		//boucle sur les onglets
		document.querySelectorAll(".fond_onglets div").forEach(element => {

			//affichage de l'onglet
			this.objCommons.bindEvent(element.id, "click", (event) => {
				const id = event.currentTarget.id;
				this.objCommons.switchOnglet(id);
				objGraphiques.stackedChart("chart_" + id, "graphique" + id);
			});
		});

		//modifie la carte en fonction de l'année selectionnée
		this.objCommons.bindEvent("annee_carte", "change", () => objCarte.create());

		//modifie la carte en fonction du type de carte selectionné
		this.objCommons.bindEvent("type_carte", "change", () => objCarte.create());

		//premier graphique
		objGraphiques.stackedChart("chart_etablissementsUtilises", "graphiqueEtablissementsUtilises");

		//création de la carte
		setTimeout(() => {
			objCarte.create();
		}, 1000);
	}
	/**
	 * Page lorsqu'un compte est connecté ailleurs
	 */
	async connexionAilleurs() {

		//renvoie vers la page de connexion
		this.objCommons.bindEvent("retour", "click", (event) => {
			this.objCommons.disableButton(event.currentTarget.id);
			location.href = "utilisateur";
		});
	}
	/**
	 * Page de changement de mot de passe
	 */
	async connexionChangerMdp() {

		//importe les modules
		const [{default: Connexion}] = await Promise.all([
			import("./connexion")
		]);

		//register les classes
		this.appContext.register("objConnexion", new Connexion(this.appContext));

		//création des objets
		const objConnexion = this.appContext.get("objConnexion");

		//valide le formulaire au keypress
		["pass", "confirm_pass"].forEach(field => {
			this.objCommons.bindEvent(field, "keypress", (event) => {

				//appuie sur "enter"
				if (event.keyCode === 13) {
					objConnexion.resetPass();
					return false;
				}
			});
		});

		//estime la securite du mot de passe
		this.objCommons.bindEvent("pass", "keyup", () => objConnexion.evalPass());

		//affiche / cache le mot de passe
		objConnexion.togglePass();

		//valide le changement de mot de passe
		this.objCommons.bindEvent("valider", "click", () => objConnexion.resetPass());

		//renvoie sur la page de connexion
		this.objCommons.bindEvent("retour", "click", (event) => {
			this.objCommons.disableButton(event.currentTarget.id);
			location.href = "../utilisateur";
		});
	}
	/**
	 * Page de connexion des élèves
	 */
	async connexionEleve() {

		//importe les modules
		const [{default: Connexion}] = await Promise.all([
			import("./connexion")
		]);

		//register les classes
		this.appContext.register("objConnexion", new Connexion(this.appContext));

		//création des objets
		const objConnexion = this.appContext.get("objConnexion");

		//valide le formulaire au keypress
		["prenom", "nom", "pass"].forEach(field => {
			this.objCommons.bindEvent(field, "keypress", (event) => {

				//appuie sur "enter"
				if (event.keyCode === 13) {
					objConnexion.eleve();
					return false;
				}
			});
		});

		//valide la connexion de l'élève
		this.objCommons.bindEvent("valider", "click", () => objConnexion.eleve());
	}
	/**
	 * Trop d'étudiants
	 */
	async connexionEtudiants() {

		//renvoie sur la page précédente
		this.objCommons.bindEvent("retour", "click", (event) => {
			this.objCommons.disableButton(event.currentTarget.id);
			location.href = php_to_js_vars.url;
		});
	}
	/**
	 * Page de connexion des patients
	 */
	async connexionPatient() {

		//importe les modules
		const [{default: Connexion}] = await Promise.all([
			import("./connexion")
		]);

		//register les classes
		this.appContext.register("objConnexion", new Connexion(this.appContext));

		//création des objets
		const objConnexion = this.appContext.get("objConnexion");

		//keypress sur les fields
		["prenom", "nom", "pass"].forEach(field => {
			this.objCommons.bindEvent(field, "keypress", (event) => {

				//appuie sur "enter"
				if (event.keyCode === 13) {
					objConnexion.patient();
					return false;
				}
			});
		});

		//valide la connexion du patient
		this.objCommons.bindEvent("valider", "click", () => objConnexion.patient());
	}
	/**
	 * Statut non autorisé
	 */
	async connexionStatut() {

		//renvoie sur la page précédente
		this.objCommons.bindEvent("retour", "click", (event) => {
			this.objCommons.disableButton(event.currentTarget.id);
			location.href = php_to_js_vars.url;
		});
	}
	/**
	 * Université non autorisée
	 */
	async connexionUniversite() {

		//renvoie sur la page précédente
		this.objCommons.bindEvent("retour", "click", (event) => {
			this.objCommons.disableButton(event.currentTarget.id);
			location.href = php_to_js_vars.url;
		});
	}
	/**
	 * Page de connexion des utilisateurs
	 */
	async connexionUtilisateur() {

		//importe les modules
		const [{default: Connexion}] = await Promise.all([
			import("./connexion")
		]);

		//register les classes
		this.appContext.register("objConnexion", new Connexion(this.appContext));

		//création des objets
		const objConnexion = this.appContext.get("objConnexion");

		//keypress sur les fields
		["login", "pass"].forEach(field => {
			this.objCommons.bindEvent(field, "keypress", (event) => {

				//appuie sur "enter"
				if (event.keyCode === 13) {
					objConnexion.utilisateur();
					return false;
				}
			});
		});

		//affiche la page de récupération des identifiants
		this.objCommons.bindEvent("pseudo_oublie", "click", () => {
			this.objCommons.setDisplay("div_connexion", "none");
			this.objCommons.setDisplay("div_recup", "block");
		});

		//affiche / cache le mot de passe
		objConnexion.togglePass();

		//valide la connexion de l'utilisateur
		this.objCommons.bindEvent("valider1", "click", () => objConnexion.utilisateur());

		//lien vers l'inscription
		this.objCommons.bindEvent("inscription", "click", (event) => {
			this.objCommons.disableButton(event.currentTarget.id);
			if (window.remember_me_choix === "enseignant") {
				location.href = php_to_js_vars.url + "inscription/etablissement";
			} else {
				location.href = php_to_js_vars.url + "inscription/orthophoniste";
			}
		});

		//keypress sur le champ email
		this.objCommons.bindEvent("email", "keypress", (event) => {

			//appuie sur "enter"
			if (event.keyCode === 13) {
				objConnexion.recupererIdentifiants();
				return false;
			}
		});

		//action sur le code uai
		this.objCommons.bindEvent("code_uai", "keyup", (event) => {

			//ignore le shift
			if (event.keyCode !== 16) {
				this.objCommons.getEtablissement();
			}
		});

		//génère le select communes
		this.objCommons.getCommunes(true);

		//valide la récupération des identifiants
		this.objCommons.bindEvent("valider2", "click", () => objConnexion.recupererIdentifiants());

		//annule la récupération des identifiants
		this.objCommons.bindEvent("retour2", "click", () => {
			this.objCommons.setDisplay("div_connexion", "block");
			this.objCommons.setDisplay("div_recup", "none");
		});

		//annule la récupération des identifiants
		this.objCommons.bindEvent("retour3", "click", () => {
			this.objCommons.setDisplay("div_recup2", "none");
			this.objCommons.setDisplay("div_connexion", "block");
		});
	}
	/**
	 * Page interdite
	 */
	async diversForbidden() {

		//renvoie sur la page précédente
		this.objCommons.bindEvent("retour", "click", (event) => {
			this.objCommons.disableButton(event.currentTarget.id);
			location.href = "javascript:history.go(-1)";
		});
	}
	/**
	 * Page avec le diaporama
	 */
	async documentsDiaporama() {

		//importe les modules
		const [{default: Carousel}] = await Promise.all([
			import("./carousel")
		]);

		//nouvel objet
		const objCarousel = new Carousel();

		//initialise le menu
		this.objMenu.documents();

		//keyup sur la page
		document.addEventListener("keyup", (event) => {
			switch (event.keyCode) {
				case 37:
					objCarousel.plusSlides(-1);
					break;
				case 39:
					objCarousel.plusSlides(1);
					break;
			}
		});

		//bouton "prev"
		const prevBtn = document.querySelector("#navigation_diaporama .prev");
		if (prevBtn) {
			prevBtn.addEventListener("click", () => {
				objCarousel.plusSlides(-1);
			});
		}

		//bouton "next"
		const nextBtn = document.querySelector("#navigation_diaporama .next");
		if (nextBtn) {
			nextBtn.addEventListener("click", () => {
				objCarousel.plusSlides(1);
			});
		}

		//tous les dots
		const dots = document.querySelectorAll("#navigation_diaporama .dot");
		dots.forEach((dot, index) => {
			dot.addEventListener("click", () => {
				objCarousel.currentSlide(index + 1);
			});
		});
	}
	/**
	 * Page avec le manuel d'utilisation
	 */
	async documentsManuel() {

		//importe les modules
		const [{default: Manuel}] = await Promise.all([
			import("./manuel")
		]);

		//nouvel objet
		new Manuel(this.appContext);

		//initialise le menu
		this.objMenu.documents();

		//initialise les titlepanes
		this.objCommons.initTitlePanes();

		//renvoie en haut de la page
		this.objCommons.bindEvent("scroll_top", "click", () => {
			document.getElementById("sommaire").scrollIntoView({
				behavior: "smooth"
			});
		});
	}
	/**
	 * Page avec la liste des documents
	 */
	async documentsVoir() {

		//recupère le cookie remember_me_choix
		const remember_me_choix = this.objCommons.getCookie("remember_me_choix") || "enseignant";

		//renvoie vers le manuel
		this.objCommons.bindEvent("lien_manuel", "click", () => {
			location.href = "manuel/" + remember_me_choix;
		});

		//diaporama
		this.objCommons.bindEvent("lien_diaporama", "click", () => {
			location.href = "diaporama/" + remember_me_choix;
		});
	}
	/**
	 * Page d'accueil d'un élève
	 */
	async eleveAccueil() {

		//importe les modules
		const [{default: Seances}, {default: Tchat}] = await Promise.all([
			import("./seances"),
			import("./tchat")
		]);

		//register les classes
		this.appContext.register("objSeances", new Seances(this.appContext));
		this.appContext.register("objTchat", new Tchat(this.appContext));

		//création des objets
		const objSeances = this.appContext.get("objSeances");

		//afficher les resultats
		this.objCommons.bindEvent("bouton_resultats", "click", () => {
			location.href = "resultats";
		});

		//si c'est un étudiant et qu'il faut demander des infos supp
		if (document.getElementById("dialog_infos_supplementaires")) {
			objSeances.dialogInfosSupplementaires();
		}

		//subscribe aux channels des groupes
		this.objRatchet.sendCommand({
			command: "subscribe",
			token: php_to_js_vars.token_subscribe
		});

		//refresh les séances
		objSeances.refresh();
	}
	/**
	 * Page de calibration d'un élève
	 */
	async eleveCalibration() {

		//importe les modules
		const [{default: Exercices}, {default: LireCouleur}, {default: Passations}, {default: Tchat}] = await Promise.all([
			import("./exercices"),
			import("./lireCouleur"),
			import("./passations"),
			import("./tchat")
		]);

		//register les classes
		this.appContext.register("objLireCouleur", new LireCouleur(this.appContext));
		this.appContext.register("objExercices", new Exercices(this.appContext));
		this.appContext.register("objPassations", new Passations(this.appContext));
		this.appContext.register("objTchat", new Tchat(this.appContext));

		//création des objets
		const objExercices = this.appContext.get("objExercices");
		const objPassations = this.appContext.get("objPassations");

		//vérifie la réponse de l'élève
		this.objCommons.bindEvent("bouton_valider_reponse", "click", () => objPassations.repondreCalibration());

		//passe à la question suivante
		this.objCommons.bindEvent("bouton_question_suivante", "click", (event) => {
			this.objCommons.disableButton(event.currentTarget.id);
			location.reload();
		});

		//action sur le bouton commentaire
		this.objCommons.bindEvent("bouton_commenter_item", "click", () => {
			objExercices.dialogCommentaire();
		});

		//ajoute un commentaire sur l'exercice
		if (document.getElementById("bouton_enregistrer_commentaire")) {

			//enregistre un commentaire
			this.objCommons.bindEvent("bouton_enregistrer_commentaire", "click", () => {
				objExercices.newCommentaire(document.getElementById("nouveau_commentaire").value, true);
			});

			//ajoute un commentaire sur l'exercice
			this.objCommons.bindEvent("nouveau_commentaire", "keypress", (event) => {

				//appuie sur "enter"
				if (event.keyCode === 13) {
					objExercices.newCommentaire(document.getElementById("nouveau_commentaire").value, true);
					return false;
				}
			});
		}

		//affiche les résultats de la calibration au clic sur le petit 2
		this.objCommons.bindEvent("lien_resultats_calibration", "click", () => objPassations.resultatsCalibration());

		//scroll jusqu'au menu
		document.getElementById("menu").scrollIntoView();

		//subscribe au channel du groupe_calibration
		this.objRatchet.sendCommand({
			command: "subscribe",
			token: php_to_js_vars.token_subscribe
		});
	}
	/**
	 * Page d'entrainement d'un élève
	 */
	async eleveEntrainement() {

		//importe les modules
		const [{default: Exercices}, {default: LireCouleur}, {default: Passations}, {default: Tchat}] = await Promise.all([
			import("./exercices"),
			import("./lireCouleur"),
			import("./passations"),
			import("./tchat")
		]);

		//register les classes
		this.appContext.register("objLireCouleur", new LireCouleur(this.appContext));
		this.appContext.register("objExercices", new Exercices(this.appContext));
		this.appContext.register("objPassations", new Passations(this.appContext));
		this.appContext.register("objTchat", new Tchat(this.appContext));

		//création des objets
		const objExercices = this.appContext.get("objExercices");
		const objPassations = this.appContext.get("objPassations");

		//problème de firefox
		if (document.getElementById("form_question_preparatoire") !== null) {
			document.getElementById("form_question_preparatoire").reset();
		}
		if (document.getElementById("form_question_principale") !== null) {
			document.getElementById("form_question_principale").reset();
		}

		//renvoie vers la page d'accueil
		this.objCommons.bindEvent("accueil", "click", (event) => {
			this.objCommons.disableButton(event.currentTarget.id);
			location.href = "../../eleve/accueil";
		});

		//subscribe au channel du groupe_entrainement
		this.objRatchet.sendCommand({
			command: "subscribe",
			token: php_to_js_vars.token_subscribe
		});

		//initialise les titlepanes
		this.objCommons.initTitlePanes();

		//s'il y a des mots aides
		if (document.getElementById("aide_prealable")) {
			objExercices.initAidePrealable();
		}

		//s'il faut afficher l'item dans un statut particulier (entrainement tutoré)
		if (php_to_js_vars.statut_entrainement) {
			objPassations.refreshStatutEntrainement(php_to_js_vars.statut_entrainement);
		}

		//vérifie la réponse de l'élève
		this.objCommons.bindEvent("bouton_valider_reponse", "click", () => objPassations.repondreEntrainement());

		//appuie sur entrée une fois le champ rempli
		this.objCommons.bindEvent("champ_ouvert_principale", "keypress", (event) => {

			//appuie sur "enter"
			if (event.keyCode === 13) {
				objPassations.repondreEntrainement();
			}
		});

		//passe à la question suivante
		this.objCommons.bindEvent("bouton_question_suivante", "click", (event) => {
			this.objCommons.disableButton(event.currentTarget.id);
			location.reload();
		});

		//scroll jusqu'au menu
		document.getElementById("menu").scrollIntoView();
	}
	/**
	 * Page d'évaluation d'un élève
	 */
	async eleveEvaluation() {

		//importe les modules
		const [{default: Exercices}, {default: LireCouleur}, {default: Passations}, {default: Tchat}] = await Promise.all([
			import("./exercices"),
			import("./lireCouleur"),
			import("./passations"),
			import("./tchat")
		]);

		//register les classes
		this.appContext.register("objLireCouleur", new LireCouleur(this.appContext));
		this.appContext.register("objExercices", new Exercices(this.appContext));
		this.appContext.register("objPassations", new Passations(this.appContext));
		this.appContext.register("objTchat", new Tchat(this.appContext));

		//création des objets
		const objPassations = this.appContext.get("objPassations");

		//problème de firefox
		if (document.getElementById("form_question_principale") !== null) {
			document.getElementById("form_question_principale").reset();
		}

		//renvoie vers la page d'accueil
		this.objCommons.bindEvent("accueil", "click", (event) => {
			this.objCommons.disableButton(event.currentTarget.id);
			location.href = "../../eleve/accueil";
		});

		//vérifie la réponse de l'élève
		this.objCommons.bindEvent("bouton_valider_reponse", "click", () => objPassations.repondreEvaluation());

		//scroll jusqu'au menu
		document.getElementById("menu").scrollIntoView();

		//subscribe au channel du groupe_evaluation 
		this.objRatchet.sendCommand({
			command: "subscribe",
			token: php_to_js_vars.token_subscribe
		});
	}
	/**
	 * Page de résultats d'un élève
	 */
	async eleveResultats() {

		//affichage de l'onglet
		document.querySelectorAll(".fond_onglets div").forEach(element => {
			this.objCommons.bindEvent(element.id, "click", (event) => {
				this.objCommons.switchOnglet(event.currentTarget.id);
			});
		});

		//renvoie vers la page d'accueil
		this.objCommons.bindEvent("accueil", "click", (event) => {
			this.objCommons.disableButton(event.currentTarget.id);
			location.href = "accueil";
		});
	}
	/**
	 * Page avec la liste des enseignant d'un établissement
	 */
	async enseignantsListe() {

		//importe les modules
		const [{default: Comptes}, {default: Enseignants}, {default: Utilisateur}] = await Promise.all([
			import("./comptes"),
			import("./enseignants"),
			import("./utilisateur")
		]);

		//création des objets
		const objComptes = new Comptes(this.appContext);
		const objEnseignants = new Enseignants(this.appContext);
		const objUtilisateur = new Utilisateur(this.appContext);

		//boucle pour chaque enseignant
		document.getElementById("tableau_enseignants").querySelectorAll("tbody tr").forEach(tr => {
			const _k = tr.id.split("_")[1];

			//renvoie les identifiants d'un enseignant
			this.objCommons.bindEvent("identifiants_" + _k, "click", () => objUtilisateur.sendIdentifiants(_k));

			//supprime l'enseignant
			this.objCommons.bindEvent("supprimer_" + _k, "click", () => objUtilisateur.dialogDelete(_k));
		});

		//ajoute un nouvel enseignant
		this.objCommons.bindEvent("bouton_creer_enseignant", "click", () => objEnseignants.openDialog());

		//rend le tableau triable par colonne
		this.objCommons.sortTable(document.getElementById("tableau_enseignants"));
	}
	/**
	 * Page des séances d'entrainement
	 */
	async entrainementsSeance() {

		//importe les modules
		const [{default: eleveParametres}, {default: Exercices}, {default: Entrainement}, {default: LireCouleur}, {default: Tchat}] = await Promise.all([
			import("./eleveParametres"),
			import("./exercices"),
			import("./entrainement"),
			import("./lireCouleur"),
			import("./tchat")
		]);

		//register les classes
		this.appContext.register("objLireCouleur", new LireCouleur(this.appContext));
		this.appContext.register("objExercices", new Exercices(this.appContext));
		this.appContext.register("objEntrainement", new Entrainement(this.appContext));
		this.appContext.register("objTchat", new Tchat(this.appContext));

		//création des objets
		const objExercices = this.appContext.get("objExercices");
		const objEleveParametres = new eleveParametres(this.appContext);
		const objEntrainement = this.appContext.get("objEntrainement");

		//initialise le menu
		this.objMenu.groupes();

		//filtre des entrainements
		this.objCommons.bindEvent("filtre_entrainements", "keyup", (event) => {
			const recherche = event.currentTarget.value.toLowerCase();

			// Récupère les entraînements
			document.getElementById("liste_groupes_entrainements").querySelectorAll(".div_bottom_container").forEach(entrainement => {
				const nom_eleve = entrainement.querySelector(".nom_eleve");
				if (nom_eleve) {

					//conserve que le nom / prénom de l'élève
					const nom_eleve_propre = nom_eleve.innerHTML.split("<")[0].trim().toLowerCase();

					// Affiche ou cache l'entraînement selon la recherche
					entrainement.style.display = (recherche === "" || nom_eleve_propre.includes(recherche)) ? "block" : "none";
				}
			});
		});

		//action sur le tri des résultats
		this.objCommons.bindEvent("tri_resultats", "change", () => objEntrainement.updateTri());

		//répartition automatique
		this.objCommons.bindEvent("repartition", "click", () => objEntrainement.dialogRepartition());

		//ouvrir tous les entrainements
		this.objCommons.bindEvent("ouvrir_tout", "click", () => objEntrainement.statut(0, "ouvert"));

		//fermer tous les entrainements
		this.objCommons.bindEvent("fermer_tout", "click", () => objEntrainement.statut(0, "ferme"));

		//s'il y a les dates (classe inversée)
		if (document.getElementById("date_debut")) {

			//date début
			this.objCommons.bindEvent("date_debut", "change", () => objEntrainement.dates());

			//heure début
			this.objCommons.bindEvent("heure_debut", "change", () => objEntrainement.dates());

			//date fin
			this.objCommons.bindEvent("date_fin", "change", () => objEntrainement.dates());

			//heure fin
			this.objCommons.bindEvent("heure_fin", "change", () => objEntrainement.dates());
		}

		//initialise les parametres
		objEntrainement.initParametres();

		//boucle pour chaque entrainement
		document.querySelectorAll("#liste_groupes_entrainements .div_bottom_container").forEach(entrainement => {
			const _k = entrainement.id.split("_")[2];

			//paramètres élèves
			const icone_parametres = entrainement.querySelector('[name="parametres_eleve"]');
			icone_parametres.addEventListener("click", () => {

				//récupère le nom de l'élève
				let nom_eleve_propre = "";
				const nom_eleve = entrainement.querySelector(".nom_eleve");
				if (nom_eleve) {

					//conserve que le nom / prénom de l'élève
					nom_eleve_propre = nom_eleve.innerHTML.split("<")[0].trim();
				}
				objEleveParametres.parametres(_k, nom_eleve_propre);
			});

			//initialise le select2
			objEntrainement.initSelectNiveau(entrainement.id);

			//paramètres
			this.objCommons.bindEvent(entrainement.id + "_parametres", "click", () => objEntrainement.parametres(_k));

			//nouvelle série
			this.objCommons.bindEvent(entrainement.id + "_nouvelle_serie", "click", (event) => {
				if (event.currentTarget.disabled !== true) {
					objEntrainement.openDialogNouvelleSerie(_k);
				}
			});

			//action sur le slider
			this.objCommons.bindEvent("slider_statut_" + entrainement.id, "change", (event) => {
				if (event.currentTarget.checked) {
					objEntrainement.statut(_k, "ouvert");
				} else {
					objEntrainement.statut(_k, "ferme");
				}
			});
		});

		//case nouvelle série
		this.objCommons.bindEvent("nouvelle_serie_all", "change", (event) => {
			const checked = event.currentTarget.checked;
			document.querySelectorAll('[name="cases_nouvelle_serie"]:not([disabled])').forEach(element => {
				element.checked = checked;
			});
		});

		//valide le lancement d'une nouvelle série
		this.objCommons.bindEvent("dialog_nouvelle_serie_valider", "click", () => objEntrainement.valideNouvelleSerie());

		//annule le lancement d'une nouvelle série
		this.objCommons.bindEvent("dialog_nouvelle_serie_annuler", "click", () => this.objDialog.hide());

		//action sur le bouton commentaire
		this.objCommons.bindEvent("bouton_commenter_item", "click", () => {
			objExercices.dialogCommentaire();
		});

		//action sur le bouton fermer item
		this.objCommons.bindEvent("fermer_show_item", "click", () => {
			this.objCommons.setDisplay("show_item", "none");
			document.querySelectorAll(".case_item").forEach(case_item => {
				case_item.classList.remove("case_item_selected");
			});
		});

		//rafraichis les cases de couleurs
		objEntrainement.refreshTableauItems();
	}
	/**
	 * Page de test d'un exercice
	 */
	async entrainementsTesterExercice() {

		//importe les modules
		const [{default: Exercices}, {default: LireCouleur}, {default: Passations}, {default: Tchat}] = await Promise.all([
			import("./exercices"),
			import("./lireCouleur"),
			import("./passations"),
			import("./tchat")
		]);

		//register les classes
		this.appContext.register("objLireCouleur", new LireCouleur(this.appContext));
		this.appContext.register("objExercices", new Exercices(this.appContext));
		this.appContext.register("objPassations", new Passations(this.appContext));
		this.appContext.register("objTchat", new Tchat(this.appContext));

		//création des objets
		const objExercices = this.appContext.get("objExercices");
		const objPassations = this.appContext.get("objPassations");

		//initialise le menu
		this.objMenu.groupes();

		//problème de firefox
		if (document.getElementById("form_question_preparatoire") !== null) {
			document.getElementById("form_question_preparatoire").reset();
		}
		if (document.getElementById("form_question_principale") !== null) {
			document.getElementById("form_question_principale").reset();
		}

		//modifie le click sur le menu intermediaire
		this.objCommons.bindEvent("menu_intermediaire", "click", () => {
			location.href = php_to_js_vars.url + "entrainements/seance/" + php_to_js_vars.id_groupe + "/" + php_to_js_vars.id_module;
		});

		//initialise les titlepanes
		this.objCommons.initTitlePanes();

		//s'il y a des mots aides
		if (document.getElementById("aide_prealable")) {
			objExercices.initAidePrealable();
		}

		//vérifie la réponse de l'élève
		this.objCommons.bindEvent("bouton_valider_reponse", "click", () => objPassations.repondreEntrainement());

		//appuie sur entrée une fois le champ rempli
		this.objCommons.bindEvent("champ_ouvert_principale", "keypress", (event) => {

			//appuie sur "enter"
			if (event.keyCode === 13) {
				objPassations.repondreEntrainement();
			}
		});

		//passe à la question suivante
		this.objCommons.bindEvent("bouton_question_suivante", "click", (event) => {
			this.objCommons.disableButton(event.currentTarget.id);
			location.reload();
		});

		//ferme l'onglet
		this.objCommons.bindEvent("bouton_fermer_onglet", "click", (event) => {
			this.objCommons.disableButton(event.currentTarget.id);
			window.close();
		});

		//scroll jusqu'au menu
		document.getElementById("menu").scrollIntoView();
	}
	/**
	 * Page d'un entrainement tutoré
	 */
	async entrainementsTutore() {

		//importe les modules
		const [{default: Exercices}, {default: Entrainement}, {default: LireCouleur}, {default: Tchat}] = await Promise.all([
			import("./exercices"),
			import("./entrainement"),
			import("./lireCouleur"),
			import("./tchat")
		]);

		//register les classes
		this.appContext.register("objLireCouleur", new LireCouleur(this.appContext));
		this.appContext.register("objExercices", new Exercices(this.appContext));
		this.appContext.register("objEntrainement", new Entrainement(this.appContext));
		this.appContext.register("objTchat", new Tchat(this.appContext));

		//création des objets
		const objLireCouleur = this.appContext.get("objLireCouleur");
		const objExercices = this.appContext.get("objExercices");
		const objEntrainement = this.appContext.get("objEntrainement");

		//initialise le menu
		this.objMenu.groupes();

		//initialise le select2
		objEntrainement.initSelectNiveau("groupe_entrainement_" + objEntrainement.idEntrainementTutore);

		//action sur le bouton types
		this.objCommons.bindEvent("types", "click", () => {
			this.objDialog.setId("dialog_types");
			this.objDialog.show();
		});

		//action sur le bouton valider types d'exercices
		this.objCommons.bindEvent("dialog_types_valider", "click", (event) => {
			this.objCommons.disableButton(event.currentTarget.id);
			//recupere les cases cochées
			let types = "";
			document.querySelectorAll('[name="checked_types"]').forEach(element => {
				if (element.checked === true) {
					types = types + element.value + ",";
				}
			});
			objEntrainement.updateParametres("types", types);
		});

		//action sur le bouton valider types d'exercices
		this.objCommons.bindEvent("dialog_types_annuler", "click", () => this.objDialog.hide());

		//paramètres
		this.objCommons.bindEvent("groupe_entrainement_" + objEntrainement.idEntrainementTutore + "_parametres", "click", () => objEntrainement.parametres(objEntrainement.idEntrainementTutore));

		//action sur le slider
		this.objCommons.bindEvent("slider_statut_groupe_entrainement_" + objEntrainement.idEntrainementTutore, "change", (event) => {
			if (event.currentTarget.checked) {
				objEntrainement.statut(objEntrainement.idEntrainementTutore, "ouvert");
			} else {
				objEntrainement.statut(objEntrainement.idEntrainementTutore, "ferme");
			}
		});

		//initialise les parametres
		objEntrainement.initParametres();

		//menu clic droit sur les cases item
		document.querySelectorAll(".items_niveau .case_item").forEach(case_item => {
			case_item.addEventListener("contextmenu", (event) => {
				objEntrainement.marquerItemTutore(case_item, event);
			});
		});

		//afficher l'exercice aux élèves
		this.objCommons.toggleButton("select_item");
		this.objCommons.bindEvent("select_item", "click", () => objEntrainement.selectItemTutore());

		//afficher/cacher les réponses élèves
		this.objCommons.bindEvent("show_reponses_eleves", "click", () => {
			objEntrainement.toggleRepEleves();
		});

		//toggle de l'affichage sequentiel
		this.objCommons.toggleButton("affichage_sequentiel");

		//reset un exercice
		this.objCommons.bindEvent("rejouer_item", "click", () => objEntrainement.resetItemTutore());

		//action sur le bouton commentaire
		this.objCommons.bindEvent("bouton_commenter_item", "click", () => {
			objExercices.dialogCommentaire();
		});

		//action sur le bouton fermer item
		this.objCommons.bindEvent("fermer_show_item", "click", () => {
			this.objCommons.setDisplay("show_item", "none");
			document.querySelectorAll(".case_item").forEach(case_item => {
				case_item.classList.remove("case_item_selected");
			});
		});

		//rafraichis les cases de couleurs
		objEntrainement.refreshTableauItems();

		//boucle pour toutes les cases
		document.querySelectorAll(".case_item").forEach((element) => {
			this.objCommons.bindEvent(element.id, "click", (event) => {
				const parts = event.currentTarget.id.split("_");
				if (parts.length !== 5) {
					return;
				}
				const id = parseInt(parts[2]);
				const timestamp = parseInt(parts[3]);
				const item = parseInt(parts[4]);
				objEntrainement.showItem(id, timestamp, item, true);
			});
		});

		//possibilité de sélectionner les mots bleus
		objLireCouleur.selectableMotsEnonce = true;
	}
	/**
	 * Page des séances d'évaluation
	 */
	async evaluationsSeance() {

		//importe les modules
		const [{default: EleveParametres}, {default: Evaluation}, {default: Tchat}] = await Promise.all([
			import("./eleveParametres"),
			import("./evaluation"),
			import("./tchat")
		]);

		//register les classes
		this.appContext.register("objEvaluation", new Evaluation(this.appContext));
		this.appContext.register("objTchat", new Tchat(this.appContext));

		//création des objets
		const objEleveParametres = new EleveParametres(this.appContext);
		const objEvaluation = this.appContext.get("objEvaluation");

		//initialise le menu
		this.objMenu.groupes();

		//action sur le bouton creer
		this.objCommons.bindEvent("bouton_creer", "click", () => objEvaluation.create("false"));

		//action sur la liste des évals
		this.objCommons.bindEvent("selected_evaluation", "change", (event) => {

			//cache les évals
			document.querySelectorAll("#liste_groupes_evaluations .span_nb_eleves, #liste_groupes_evaluations .div_titre_boutons, #liste_groupes_evaluations .div_resultats_evaluations").forEach(div => {
				div.style.display = "none";
			});

			//affiche l'évaluation sélectionnée
			const value = event.currentTarget.value;
			this.objCommons.setDisplay("evaluation_" + value + "_nb_eleves", "inline-block");
			this.objCommons.setDisplay("evaluation_" + value + "_boutons", "block");
			this.objCommons.setDisplay("evaluation_" + value + "_resultats", "block");
		});

		//boucle pour chaque slider
		document.querySelectorAll("#liste_groupes_evaluations .div_titre_boutons").forEach(tr => {
			const _k = tr.id.split("_")[1];

			//action sur le slider
			this.objCommons.bindEvent("slider_statut_evaluation_" + _k, "change", (event) => {
				if (event.currentTarget.checked) {
					objEvaluation.statut(_k, "ouvert");
				} else {
					objEvaluation.statut(_k, "ferme");
				}
			});
		});

		//boucle pour chaque case_item
		document.querySelectorAll("#liste_groupes_evaluations .case_item").forEach(case_item => {

			//action sur les cases item
			this.objCommons.bindEvent(case_item.id, "click", (event) => {
				const id = event.currentTarget.id.split("_");
				objEvaluation.showItem(id[0], id[3]);
			});
		});

		//boucle pour chaque div_resultats_evaluations
		document.querySelectorAll(".div_resultats_evaluations").forEach(resultats_evaluations => {
			const num_eval = resultats_evaluations.id.split("_")[1];

			//boucle pour chaque élève
			resultats_evaluations.querySelectorAll(".table_evaluation_detail tbody>tr").forEach(eleve => {

				//paramètres élèves
				const icone_parametres = eleve.querySelector('[name="parametres_eleve"]');
				icone_parametres.addEventListener("click", () => {

					//récupère le nom de l'élève
					let nom_eleve_propre = "";
					const nom_eleve = eleve.querySelector(".nom_eleve");
					if (nom_eleve) {

						//conserve que le nom / prénom de l'élève
						nom_eleve_propre = nom_eleve.innerHTML.split("<")[0].trim();
					}
					objEleveParametres.parametres(eleve.dataset.id, nom_eleve_propre);
				});

				//anulation d'une éval
				const icone_annulation = eleve.querySelector(".icone-trash");
				if (icone_annulation) {
					icone_annulation.addEventListener("click", () => {
						objEvaluation.dialogDelete(eleve.dataset.id, num_eval)
					});
				}
			});
		});

		//rend les tableaux de détails sortable
		document.querySelectorAll(".table_evaluation_detail").forEach(table => {
			this.objCommons.sortTable(table);
		});

		//refresh des donnees des evaluations
		objEvaluation.refresh();
	}
	/**
	 * Page avec la liste des bordereaux
	 */
	async facturationBordereaux() {

		//importe les modules
		const [{default: Bordereau}] = await Promise.all([
			import("./bordereau")
		]);

		//nouvel objet
		const objBordereau = new Bordereau(this.appContext);

		//initialise le menu
		this.objMenu.facturation();

		//renvoie a la page sélectionnée
		this.objCommons.bindEvent("num_page", "change", (event) => {
			location.href = event.currentTarget.value;
		});

		//lance la création d'un nouveau bordereau publics
		this.objCommons.bindEvent("bouton_creer_bordereau_public", "click", (event) => {
			this.objCommons.disableButton(event.currentTarget.id);
			objBordereau.create("Public");
		});

		//lance la création d'un nouveau bordereau privés
		this.objCommons.bindEvent("bouton_creer_bordereau_prive", "click", (event) => {
			this.objCommons.disableButton(event.currentTarget.id);
			objBordereau.create("Privé");
		});

		//boucle pour chaque bordereau
		document.querySelectorAll("#tableau_bordereaux tbody>tr").forEach(bordereau => {
			const id_bordereau = bordereau.id.split("_")[1];

			//ajoute un fichier
			bordereau.querySelectorAll('input[type="file"]').forEach(element => {
				element.addEventListener("change", () => objBordereau.importFichiers(id_bordereau, element.dataset.statut));
			});

			//supprime le bordereau
			bordereau.querySelectorAll(".icone-trash").forEach(element => {
				element.addEventListener("click", () => objBordereau.dialogDelete(id_bordereau));
			});
		});
	}
	/**
	 * Page de liste des devis
	 */
	async facturationDevis() {

		//initialise le menu
		this.objMenu.facturation();

		//renvoie a la page sélectionnée
		this.objCommons.bindEvent("num_page", "change", (event) => {
			location.href = event.currentTarget.value;
		});

		//lance une recherche sur les devis
		this.objCommons.bindEvent("rechercher_devis", "keypress", (event) => {

			//appuie sur "enter"
			if (event.keyCode === 13) {
				const _search_value = event.currentTarget.value;
				if (_search_value !== "") {
					location.href = "?search=" + _search_value;
				}
				return false;
			}
		});

		//lance une recherche sur les devis
		this.objCommons.bindEvent("bouton_rechercher_devis", "click", () => {
			const _search_value = document.getElementById("rechercher_devis").value;
			if (_search_value !== "") {
				location.href = "?search=" + _search_value;
			}
		});

		//annule une recherche
		this.objCommons.bindEvent("bouton_cancel_rechercher_devis", "click", () => {
			location.href = "1";
		});
	}
	/**
	 * Page avec la liste des commandes
	 */
	async facturationListe() {

		//importe les modules
		const [{default: Commandes}, {default: Facturation}] = await Promise.all([
			import("./commandes"),
			import("./facturation")
		]);

		//nouvel objet
		const objCommandes = new Commandes(this.appContext);
		const objFacturation = new Facturation(this.appContext);

		//initialise le menu
		this.objMenu.facturation();

		//filtre les commandes en fonction du statut
		this.objCommons.bindEvent("statut_commande", "change", (event) => {
			let _url = "../1/" + event.currentTarget.value;
			const _search_value = document.getElementById("rechercher_commandes").value;
			if (_search_value !== "") {
				_url += "?search=" + _search_value;
			}
			location.href = _url;
		});

		//renvoie a la page sélectionnée
		this.objCommons.bindEvent("num_page", "change", (event) => {
			let _url = "../" + event.currentTarget.value + "/" + document.getElementById("statut_commande").value;
			const _search_value = document.getElementById("rechercher_commandes").value;
			if (_search_value !== "") {
				_url += "?search=" + _search_value;
			}
			location.href = _url;
		});

		//importe le fichier
		this.objCommons.bindEvent("file_xlsx", "change", () => {
			document.getElementById("input_file_import_txt").innerHTML = "<img src='/img/loading1.gif' style='margin:2px 0 -3px 0;'> Veuillez patienter...";
			objFacturation.updatePaiements();
		});

		//lance une recherche sur les commandes
		this.objCommons.bindEvent("rechercher_commandes", "keypress", (event) => {

			//appuie sur "enter"
			if (event.keyCode === 13) {
				const _search_value = event.currentTarget.value;
				if (_search_value !== "") {
					location.href = "?search=" + _search_value;
				}
				return false;
			}
		});

		//lance une recherche sur les commandes
		this.objCommons.bindEvent("bouton_rechercher_commandes", "click", () => {
			const _search_value = document.getElementById("rechercher_commandes").value;
			if (_search_value !== "") {
				location.href = "?search=" + _search_value;
			}
		});

		//annule une recherche
		this.objCommons.bindEvent("bouton_cancel_rechercher_commandes", "click", () => {
			location.href = "all";
		});

		//privilégie le scoll horizontal dans le tableau
		this.objCommons.bindEvent("div_tableau_commandes", "wheel", (event) => {
			const delta = Math.sign(event.deltaY);
			document.getElementById("div_tableau_commandes").scrollLeft += (delta * 80);
			event.preventDefault();
		});

		//highligth du tr au survol du numéro
		document.querySelectorAll("#tableau_commandes tbody>tr").forEach(commande => {
			const num_commande = commande.id.split("_")[1];
			commande.addEventListener("mouseover", () => {
				commande.style.backgroundColor = "#f5f5f5";
			});
			commande.addEventListener("mouseout", () => {
				commande.style.backgroundColor = "white";
			});

			//annulation de commande
			commande.querySelectorAll('[name="cancel_commande"]').forEach(element => {
				element.addEventListener("click", () => objCommandes.dialogCancel(num_commande));
			});

			//validation du paiement
			commande.querySelectorAll('[name="valide_paiement"]').forEach(element => {
				element.addEventListener("click", () => objFacturation.dialogPaiement(num_commande));
			});

			//dépôt bdc
			commande.querySelectorAll('[name="depot_bdc"]').forEach(element => {
				element.addEventListener("click", () => objCommandes.dialogDepotBonDeCommande(num_commande));
			});

			//validation du bdc
			commande.querySelectorAll('[name="valide_bdc"]').forEach(element => {
				element.addEventListener("click", () => objFacturation.dialogVerificationBonDeCommande(num_commande));
			});

			//annulation du bdc
			commande.querySelectorAll('[name="delete_bdc"]').forEach(element => {
				element.addEventListener("click", () => objFacturation.dialogDeleteBonDeCommande(num_commande));
			});

			//déblocage compte
			commande.querySelectorAll('[name="deblocage_compte"]').forEach(element => {
				element.addEventListener("click", () => objFacturation.dialogBlocage(num_commande, false));
			});

			//blocage compte
			commande.querySelectorAll('[name="blocage_compte"]').forEach(element => {
				element.addEventListener("click", () => objFacturation.dialogBlocage(num_commande, true));
			});

			//remarques
			commande.querySelectorAll('[name="remarques"]').forEach(element => {
				element.addEventListener("focusout", () => objFacturation.update(num_commande, "remarques", element.innerText));
			});
		});

		//rend le tableau sortable
		this.objCommons.sortTable(document.getElementById("tableau_commandes"));
	}
	/**
	 * Page avec les payeurs
	 */
	async facturationPayeurs() {

		//importe les modules
		const [{default: Payeur}] = await Promise.all([
			import("./payeur")
		]);

		//nouvel objet
		const objPayeur = new Payeur(this.appContext);

		//initialise le menu
		this.objMenu.facturation();

		//filtre les payeurs en fonction du sifac
		this.objCommons.bindEvent("sifac_payeur", "change", (event) => {
			let _url = "../1/" + event.currentTarget.value;
			const _search_value = document.getElementById("rechercher_payeurs").value;
			if (_search_value !== "") {
				_url += "?search=" + _search_value;
			}
			location.href = _url;
		});

		//renvoie a la page sélectionnée
		this.objCommons.bindEvent("num_page", "change", (event) => {
			let _url = "../" + event.currentTarget.value + "/" + document.getElementById("sifac_payeur").value;
			const _search_value = document.getElementById("rechercher_payeurs").value;
			if (_search_value !== "") {
				_url += "?search=" + _search_value;
			}
			location.href = _url;
		});

		//lance une recherche sur les payeurs
		this.objCommons.bindEvent("rechercher_payeurs", "keypress", (event) => {

			//appuie sur "enter"
			if (event.keyCode === 13) {
				const _search_value = event.currentTarget.value;
				if (_search_value !== "") {
					location.href = "?search=" + _search_value;
				}
				return false;
			}
		});

		//lance une recherche sur les payeurs
		this.objCommons.bindEvent("bouton_rechercher_payeurs", "click", () => {
			const _search_value = document.getElementById("rechercher_payeurs").value;
			if (_search_value !== "") {
				location.href = "?search=" + _search_value;
			}
		});

		//annule une recherche
		this.objCommons.bindEvent("bouton_cancel_rechercher_payeurs", "click", () => {
			location.href = "sans";
		});

		//boucle pour chaque formulaire de la page
		if (document.getElementById("tableau_payeurs")) {
			document.getElementById("tableau_payeurs").querySelectorAll("tbody tr").forEach(tr => {
				const _k = tr.id.split("_")[1];

				//prevalide
				this.objCommons.bindEvent("td_" + _k + "_etat", "click", () => objPayeur.prevalide(_k));
			});
		}

		//boucle pour chaque payeur
		document.querySelectorAll("#tableau_payeurs tbody>tr").forEach(payeur => {
			const id_payeur = payeur.id.split("_")[1];

			//met à jour le sifac
			payeur.querySelectorAll('[name="update_sifac"]').forEach(element => {
				element.addEventListener("focusout", () => objPayeur.update(id_payeur, "id_sifac", element.innerText));
			});

			//met à jour le siret
			payeur.querySelectorAll('[name="update_siret"]').forEach(element => {
				element.addEventListener("focusout", () => objPayeur.update(id_payeur, "siret", element.innerText));
			});
		});

		//rend le tableau sortable
		this.objCommons.sortTable(document.getElementById("tableau_payeurs"));
	}
	/**
	 * Page avec le résumé des commandes
	 */
	async facturationResume() {

		//importe les modules
		const [{default: Graphiques}, {default: Facturation}] = await Promise.all([
			import("./graphiques"),
			import("./facturation")
		]);

		//nouvel objet
		const objGraphiques = new Graphiques(this.appContext);
		const objFacturation = new Facturation(this.appContext);

		//initialise le menu
		this.objMenu.facturation();

		//renvoie a la page de l'année sélectionnée
		this.objCommons.bindEvent("annee_commande", "change", (event) => {
			location.href = event.currentTarget.value;
		});

		//affichage de l'onglet
		document.querySelectorAll(".fond_onglets div").forEach(element => {

			//click sur l'onglet
			this.objCommons.bindEvent(element.id, "click", (event) => {
				this.objCommons.switchOnglet(event.currentTarget.id);

				//affiche le graphique
				switch (element.id) {
					case  "commandes_30_jours":
						objGraphiques.commandes30Jours();
						break;
					case  "licences_types":
						objGraphiques.stackedChart("chart_licences_types", "../graphiqueLicencesTypes/scolaire/true");
						break;
					case  "licences_types_civile":
						objGraphiques.stackedChart("chart_licences_types_civile", "../graphiqueLicencesTypes/civile/true");
						break;
					case  "licences_renouvellements":
						objGraphiques.stackedChart("chart_licences_renouvellements", "../graphiqueLicencesRenouvellements");
						break;
					case  "licences_paquets":
						objGraphiques.stackedChart("chart_licences_paquets", "../graphiqueLicencesPaquets");
						break;
				}
			});
		});

		//ouvre le dialog de nouvelle dépense
		this.objCommons.bindEvent("bouton_nouvelle_depense", "click", () => objFacturation.dialogNouvelleDepense());

		//ouvre le dialog de nouvelle dépense
		if (document.getElementById("chart_licences_types")) {

			//checkbox licences type
			this.objCommons.bindEvent("checkbox_licences_types", "change", (event) => {
				const chart = objGraphiques.chartInstances["chart_licences_types"];
				if (chart) {
					chart.destroy();
					delete objGraphiques.chartInstances["chart_licences_types"];
				}

				//si c'est coché on relance la fonction
				if (event.currentTarget.checked) {
					objGraphiques.stackedChart("chart_licences_types", "../graphiqueLicencesTypes/scolaire/true");
				} else {
					objGraphiques.stackedChart("chart_licences_types", "../graphiqueLicencesTypes/scolaire/false");
				}
			});

			//checkbox licences type
			this.objCommons.bindEvent("checkbox_licences_types_civile", "change", (event) => {
				const chart = objGraphiques.chartInstances["chart_licences_types_civile"];
				if (chart) {
					chart.destroy();
					delete objGraphiques.chartInstances["chart_licences_types_civile"];
				}

				//si c'est coché on relance la fonction
				if (event.currentTarget.checked) {
					objGraphiques.stackedChart("chart_licences_types_civile", "../graphiqueLicencesTypes/civile/true");
				} else {
					objGraphiques.stackedChart("chart_licences_types_civile", "../graphiqueLicencesTypes/civile/false");
				}
			});
		}

		//rend le tableau sortable
		if (document.getElementById("tableau_all_commandes")) {
			this.objCommons.sortTable(document.getElementById("tableau_all_commandes"));
		}
	}
	/**
	 * Page d'accueil du forum
	 */
	async forumDiscussions() {

		//lance une recherche sur le forum
		this.objCommons.bindEvent("rechercher_forum", "keypress", (event) => {

			//appuie sur "enter"
			if (event.keyCode === 13) {
				const _search_value = event.currentTarget.value;
				if (_search_value !== "") {
					location.href = "rechercher/1?search=" + _search_value;
				}
				return false;
			}
		});

		//boucle pour chaque discussion
		document.querySelectorAll(".sujet_titre").forEach(discussion => {
			const _k = discussion.id.split("_")[1];

			//renvoie vers la discussion
			this.objCommons.bindEvent("lien_" + _k, "click", () => {
				location.href = "listeSujets/" + _k + "/1";
			});
		});
	}
	/**
	 * Page avec la liste des sujets d'une discussion
	 */
	async forumListeSujets() {

		//importe les modules
		const [{default: Forum}] = await Promise.all([
			import("./forum")
		]);

		//nouvel objet
		const objForum = new Forum(this.appContext);

		//initialise le menu
		this.objMenu.forum();

		//renvoie a la page sélectionnée
		this.objCommons.bindEvent("num_page", "change", (event) => {
			location.href = event.currentTarget.value;
		});

		//créer un nouveau sujet
		this.objCommons.bindEvent("bouton_nouveau_sujet", "click", () => objForum.openDialogSujet(null));

		//boucle pour chaque sujet
		document.getElementById("tableau_sujets").querySelectorAll("tbody tr").forEach(tr => {
			const _k = tr.id.split("_")[1];

			//renvoie vers le sujet
			this.objCommons.bindEvent("lien_" + _k, "click", () => {
				location.href = "../../sujet/" + _k;
			});

			//modifie un sujet
			this.objCommons.bindEvent("modifier_" + _k, "click", () => objForum.openDialogSujet(_k));

			//supprime un sujet
			this.objCommons.bindEvent("supprimer_" + _k, "click", () => objForum.dialogDeleteSujet(_k));
		});
	}
	/**
	 * Page avec les résultats d'une recherche dans le forum
	 */
	async forumRechercher() {

		//initialise le menu
		this.objMenu.forum();

		//renvoie a la page sélectionnée
		this.objCommons.bindEvent("num_page", "change", (event) => {
			location.href = event.currentTarget.value;
		});

		//lance une recherche sur les sujets
		this.objCommons.bindEvent("rechercher_forum", "keypress", (event) => {

			//appuie sur "enter"
			if (event.keyCode === 13) {
				const _search_value = event.currentTarget.value;
				if (_search_value !== "") {
					location.href = "1?search=" + _search_value;
				}
				return false;
			}
		});

		//boucle pour chaque sujet
		document.querySelectorAll("#tableau_sujets tbody tr").forEach(tr => {
			const _k = tr.id.split("_")[1];

			//renvoie vers le sujet
			this.objCommons.bindEvent("lien_" + _k, "click", () => {
				location.href = "../sujet/" + _k;
			});
		});
	}
	/**
	 * Page d'un sujet du forum
	 */
	async forumSujet() {

		//importe les modules
		const [{default: Forum}] = await Promise.all([
			import("./forum")
		]);

		//nouvel objet
		const objForum = new Forum(this.appContext);

		//initialise le menu
		this.objMenu.forum();

		//créer un nouveau post
		this.objCommons.bindEvent("bouton_nouveau_post", "click", () => objForum.openDialogPost(null));

		//indique le sujet comme résolu
		this.objCommons.bindEvent("bouton_resolu", "click", () => objForum.setResolu());

		//boucle pour chaque sujet
		document.querySelectorAll(".forum_posted_by").forEach(tr => {
			const _k = tr.id.split("_")[1];

			//signale un post
			this.objCommons.bindEvent("signaler_" + _k, "click", () => objForum.openDialogSignaler(_k));

			//modifie un post
			this.objCommons.bindEvent("modifier_" + _k, "click", () => objForum.openDialogPost(_k));

			//supprime un post
			this.objCommons.bindEvent("supprimer_" + _k, "click", () => objForum.dialogDeletePost(_k));
		});
	}
	/**
	 * Page de création d'un groupe
	 */
	async groupesCreer() {

		//importe les modules
		const [{default: Groupes}] = await Promise.all([
			import("./groupes")
		]);

		//nouvel objet
		const objGroupes = new Groupes(this.appContext);

		//initialise le menu
		this.objMenu.groupes();

		//filtre les élèves
		this.objCommons.bindEvent("filtre_eleves", "keyup", () => objGroupes.filtreEleves());

		//s'il y a des classes
		if (document.getElementById("classes_dndsource")) {

			//boucle pour chaque classe
			document.querySelectorAll(".dndClasse").forEach(classe => {
				const _k = classe.id.split("_")[1];

				//ouvre l'arborescence d'une classe
				this.objCommons.bindEvent("classe_" + _k, "click", (event) => {
					let display = "inline-flex";

					//si le dossier est fermé
					if (document.getElementById("icone_" + _k).classList.contains("icone-folder_close")) {
						document.getElementById("icone_" + _k).classList.remove("icone-folder_close");
						document.getElementById("icone_" + _k).classList.add("icone-folder_open");
					} else {
						display = "none";
						document.getElementById("icone_" + _k).classList.remove("icone-folder_open");
						document.getElementById("icone_" + _k).classList.add("icone-folder_close");
					}

					//affiche cache les élèves
					document.querySelectorAll('#classes_dndsource [data-dndparent="' + _k + '"]').forEach(element => {

						//s'il faut cacher
						if (display === "none") {
							element.style.setProperty("display", "none", "important");
						} else if (document.getElementById("filtre_eleves").value !== "") {
							objGroupes.filtreEleves();
						} else {
							element.style.display = display;
						}
					});

					//scroll jusqu'à l'élément
					const topPos = event.currentTarget.offsetTop - 150;
					document.getElementById("classes_scroll").scrollTop = topPos;
				});
			});

			//initialise le Dnd des élèves
			objGroupes.initDnd();

			//boucle pour chaque auteurs
			document.querySelectorAll(".auteurs_rubrique_items").forEach(auteur => {

				//action sur le click des auteurs
				auteur.addEventListener("click", (event) => {
					event.preventDefault();
					this.objCommons.showAuteurs(event.currentTarget.id.split("_")[1]);
				});
			});

			//valide la deuxième etape
			this.objCommons.bindEvent("valide", "click", () => objGroupes.create());
		}

		//s'il y a des élèves
		document.querySelectorAll("#groupe-classe_dndsource .icone-trash").forEach(eleve => {
			eleve.addEventListener("click", (event) => {
				objGroupes.destroyEleve(event.currentTarget);
			});
		});
	}
	/**
	 * Page avec la liste des groupes d'un enseignant
	 */
	async groupesListe() {

		//importe les modules
		const [{default: Groupes}, {default: Tchat}] = await Promise.all([
			import("./groupes"),
			import("./tchat")
		]);

		//register les classes
		this.appContext.register("objTchat", new Tchat(this.appContext));

		//création des objets
		const objGroupes = new Groupes(this.appContext);

		//inscription aux calibrations
		this.objCommons.bindEvent("participer_calibration", "click", () => {

			//importe les modules
			import("./calibration").then(({ default: Calibration }) => {
				this.appContext.register("objCalibration", new Calibration(this.appContext));
				const objCalibration = this.appContext.get("objCalibration");
				objCalibration.participer();
			});
		});

		//créer un nouveau groupe
		this.objCommons.bindEvent("bouton_creer", "click", (event) => {
			this.objCommons.disableButton(event.currentTarget.id);
			location.href = "creer/0";
		});

		//importer du GAR
		this.objCommons.bindEvent("bouton_importer_gar", "click", (event) => {
			this.objCommons.disableButton(event.currentTarget.id);
			objGroupes.importerGar();
		});

		//boucle pour chaque groupe
		document.querySelectorAll(".div_rubrique").forEach(groupe => {
			const _k = groupe.id.split("_")[1];

			//envoie sur la page de calibrations
			this.objCommons.bindEvent("calibrations_" + _k, "click", () => {
				location.href = "../calibrations/seance/" + _k;
			});

			//télécharge les cartes eleves
			this.objCommons.bindEvent("cartes_pdf_" + _k, "click", () => {
				window.open("../documents/cartesPdf/groupe/" + _k);
			});

			//envoie sur la page de modification
			this.objCommons.bindEvent("modifier_" + _k, "click", () => {
				location.href = "creer/" + _k;
			});

			//ouvre le dialog de confirmation de suppression
			this.objCommons.bindEvent("supprimer_" + _k, "click", () => objGroupes.dialogDelete(_k));
		});
	}
	/**
	 * Page de génération d'un devis
	 */
	async inscriptionDevis() {

		//importe les modules
		const [{default: Inscription}] = await Promise.all([
			import("./inscription")
		]);

		//nouvel objet
		const objInscription = new Inscription(this.appContext);

		//initialise le menu
		if (php_to_js_vars.statut) {
			this.objMenu.licence();
		}

		//génère un captcha
		objInscription.getCaptcha();

		//initialise les titlepanes
		this.objCommons.initTitlePanes();

		//génère le select pays
		this.objCommons.getPays(false).then(() => {

			//met a jour le prix total
			this.objCommons.updatePrix();
			this.objCommons.bindEvent("nb_licences", "change", () => this.objCommons.updatePrix());
		});

		//valide le formulaire des infos du devis
		this.objCommons.bindEvent("check_infos", "click", () => {

			//si le formulaire est ok
			if (document.getElementById("infos_form").checkValidity() && $("#pays_etablissement").selectize()[0].selectize.getValue() !== "") {

				//ouvre l'étape suivante
				this.objCommons.titlePaneSlide("infos", "nb_licences");
			} else {

				//affiche les champs invalides
				this.objCommons.highlightInvalid("infos_form");
			}
		});

		//valide le formulaire du nb de licences
		this.objCommons.bindEvent("check_nb_licences", "click", () => {

			//si le formulaire est ok
			if (document.getElementById("nb_licences_form").checkValidity()) {

				//ouvre l'étape suivante
				this.objCommons.titlePaneSlide("nb_licences", "finalisation");
			} else {

				//affiche les champs invalides
				this.objCommons.highlightInvalid("nb_licences_form");
			}
		});

		//rafraichi l'image captcha
		this.objCommons.bindEvent("refresh_captcha", "click", () => objInscription.getCaptcha());

		//finalise l'inscription
		this.objCommons.bindEvent("check_finalisation", "click", () => objInscription.createDevis());

		//annule la création du devis
		this.objCommons.bindEvent("cancel_finalisation", "click", (event) => {
			this.objCommons.disableButton(event.currentTarget.id);
			history.back();
		});

		//action sur le bouton retour
		this.objCommons.bindEvent("retour", "click", (event) => {
			this.objCommons.disableButton(event.currentTarget.id);
			history.back();
		});
	}
	/**
	 * Page d'inscription d'un établissement
	 */
	async inscriptionEtablissement() {

		//importe les modules
		const [{default: Inscription}] = await Promise.all([
			import("./inscription")
		]);

		//nouvel objet
		const objInscription = new Inscription(this.appContext);

		//génère un captcha
		objInscription.getCaptcha();

		//initialise les titlepanes
		this.objCommons.initTitlePanes();

		//s'il y a un code uai pré-rempli (accès GAR)
		if (document.getElementById("code_uai").value != "") {

			//génère un dialog pour la confirmation d'inscription
			objInscription.dialogGar();
		}

		//génère le select communes
		this.objCommons.getCommunes(true).then(() => {

			//action sur le bouton etablissement_avec_uai
			this.objCommons.bindEvent("etablissement_avec_uai", "change", (event) => {
				if (event.currentTarget.checked === true) {
					this.objCommons.updateOrganismeForm();
				}
			});

			//action sur le bouton etablissement_sans_uai
			this.objCommons.bindEvent("etablissement_sans_uai", "change", (event) => {
				if (event.currentTarget.checked === true) {
					this.objCommons.updateOrganismeForm();
				}
			});

			//action sur le code uai
			this.objCommons.bindEvent("code_uai", "keyup", (event) => {

				//ignore le shift
				if (event.keyCode !== 16) {
					this.objCommons.getEtablissement();
				}
			});

			//génère le select pays
			this.objCommons.getPays(true);

			//au moment du choix du type d'étab
			this.objCommons.bindEvent("type_etablissement", "change", () => {
				this.objCommons.updateOrganismeForm();
			});

			//valide le formulaire des infos persos
			this.objCommons.bindEvent("check_infos", "click", () => objInscription.checkInfos());

			//importe le fichier
			this.objCommons.bindEvent("fichier_justificatif", "change", () => this.objCommons.checkJustificatif("pedagogie_form_errors"));

			//valide le formulaire du projet pédagogique
			this.objCommons.bindEvent("check_pegagogie", "click", () => objInscription.checkPedagogie());

			//rafraichi l'image captcha
			this.objCommons.bindEvent("refresh_captcha", "click", () => objInscription.getCaptcha());

			//finalise l'inscription
			this.objCommons.bindEvent("check_finalisation", "click", () => objInscription.checkFinalisation());
		});
	}
	/**
	 * Page d'inscription d'un orthophoniste
	 */
	async inscriptionOrthophoniste() {

		//importe les modules
		const [{default: Inscription}] = await Promise.all([
			import("./inscription")
		]);

		//nouvel objet
		const objInscription = new Inscription(this.appContext);

		//génère un captcha
		objInscription.getCaptcha();

		//initialise les titlepanes
		this.objCommons.initTitlePanes();

		//génère le select communes
		this.objCommons.getCommunes(false).then(() => {

			//génère le select pays
			this.objCommons.getPays(false);

			//valide le formulaire des infos persos
			this.objCommons.bindEvent("check_infos", "click", () => objInscription.checkInfos());

			//importe le fichier
			this.objCommons.bindEvent("fichier_justificatif", "change", () => this.objCommons.checkJustificatif("infos_form_errors"));

			//rafraichi l'image captcha
			this.objCommons.bindEvent("refresh_captcha", "click", () => objInscription.getCaptcha());

			//finalise l'inscription
			this.objCommons.bindEvent("check_finalisation", "click", () => objInscription.checkFinalisation());
		});
	}
	/**
	 * Page d'inscription d'un organisme public
	 */
	async inscriptionOrganismePublic() {

		//importe les modules
		const [{default: Inscription}] = await Promise.all([
			import("./inscription")
		]);

		//nouvel objet
		const objInscription = new Inscription(this.appContext);

		//génère un captcha
		objInscription.getCaptcha();

		//initialise les titlepanes
		this.objCommons.initTitlePanes();

		//génère le select communes
		this.objCommons.getCommunes(false).then(() => {

			//génère le select pays
			this.objCommons.getPays(false);

			//valide le formulaire des infos persos
			this.objCommons.bindEvent("check_infos", "click", () => objInscription.checkInfos());

			//rafraichi l'image captcha
			this.objCommons.bindEvent("refresh_captcha", "click", () => objInscription.getCaptcha());

			//finalise l'inscription
			this.objCommons.bindEvent("check_finalisation", "click", () => objInscription.checkFinalisation());
		});
	}
	/**
	 * Page de confirmation d'une inscription
	 */
	async inscriptionTerminee() {

		//action sur le bouton retour
		this.objCommons.bindEvent("accueil", "click", (event) => {
			this.objCommons.disableButton(event.currentTarget.id);
			location.href = php_to_js_vars.url;
		});
	}
	/**
	 * Page de création d'un compte test
	 */
	async inscriptionTest() {

		//importe les modules
		const [{default: Inscription}] = await Promise.all([
			import("./inscription")
		]);

		//nouvel objet
		const objInscription = new Inscription(this.appContext);

		//génère un captcha
		objInscription.getCaptcha();

		//rafraichi l'image captcha
		this.objCommons.bindEvent("refresh_captcha", "click", () => objInscription.getCaptcha());

		//valide la création du compte test
		this.objCommons.bindEvent("valide_compte_test", "click", () => objInscription.checkFinalisation());
	}
	/**
	 * Page de création d'un item
	 */
	async itemsCreation() {

		//importe les modules
		const [{default: Item}, {default: Mots}] = await Promise.all([
			import("./item"),
			import("./mots")
		]);

		//nouvel objet
		const objItem = new Item(this.appContext);
		const objMots = new Mots(this.appContext);

		//initialise le menu
		this.objMenu.items();

		//change le module
		this.objCommons.bindEvent("id_module", "change", (event) => {
			location.href = event.currentTarget.value;
		});

		//change le type d'exercice
		this.objCommons.bindEvent("item_type", "change", () => objItem.getType());

		//recupere la regle et l'item exemple
		objItem.getType();

		//s'il y a des mots cibles
		if (document.getElementById("add_mot_cible")) {
			objMots.addMotCible();

			//ajoute un mot cible
			this.objCommons.bindEvent("add_mot_cible", "click", () => objMots.addMotCible());
		}

		//initialise le module tinymce
		objItem.initTinymce();

		//action sur les boutons d'ajout de réponses
		this.objCommons.bindEvent("question_preparatoire_add_bonne_reponse", "click", () => objItem.addReponse("question_preparatoire", "bonne_reponse"));
		this.objCommons.bindEvent("question_preparatoire_add_mauvaise_reponse", "click", () => objItem.addReponse("question_preparatoire", "mauvaise_reponse"));

		//action sur les boutons d'ajout de réponses
		this.objCommons.bindEvent("question_principale_add_bonne_reponse", "click", () => objItem.addReponse("question_principale", "bonne_reponse"));
		this.objCommons.bindEvent("question_principale_add_mauvaise_reponse", "click", () => objItem.addReponse("question_principale", "mauvaise_reponse"));

		//supprime une réponse
		document.querySelectorAll('[name="delete_reponse"]').forEach(element => {
			const id_reponse = element.id.replace("supprimer_", "");
			element.addEventListener("click", () => {
				objItem.deleteReponse(id_reponse);
			});
		});

		//valide la création d'un item
		this.objCommons.bindEvent("valider", "click", () => objItem.create());
	}
	/**
	 * Page de duplication d'un item
	 */
	async itemsDuplication() {

		//importe les modules
		const [{default: Item}, {default: Mots}] = await Promise.all([
			import("./item"),
			import("./mots")
		]);

		//nouvel objet
		const objItem = new Item(this.appContext);
		const objMots = new Mots(this.appContext);

		//initialise le menu
		this.objMenu.items();

		//initialise le module tinymce
		objItem.initTinymce();

		//change le type d'exercice
		this.objCommons.bindEvent("item_type", "change", () => objItem.getType());

		//recupere la regle et l'item exemple
		objItem.getType();

		//ajoute un mot cible
		this.objCommons.bindEvent("add_mot_cible", "click", () => objMots.addMotCible());

		//s'il y a des mots cibles
		if (php_to_js_vars.mots_cibles.length > 0) {
			Object.values(php_to_js_vars.mots_cibles).forEach(mot => {
				objMots.addMotCible(mot);
			});
		}

		//action sur les boutons d'ajout de réponses
		this.objCommons.bindEvent("question_preparatoire_add_bonne_reponse", "click", () => objItem.addReponse("question_preparatoire", "bonne_reponse"));
		this.objCommons.bindEvent("question_preparatoire_add_mauvaise_reponse", "click", () => objItem.addReponse("question_preparatoire", "mauvaise_reponse"));

		//action sur les boutons d'ajout de réponses
		this.objCommons.bindEvent("question_principale_add_bonne_reponse", "click", () => objItem.addReponse("question_principale", "bonne_reponse"));
		this.objCommons.bindEvent("question_principale_add_mauvaise_reponse", "click", () => objItem.addReponse("question_principale", "mauvaise_reponse"));

		//affiche les mots en double
		objItem.duplicateWords(php_to_js_vars.mots_communs);

		//action sur le bouton comparer
		this.objCommons.bindEvent("comparer", "click", () => {

			//compare l'enonce
			objItem.compareStrings(document.getElementById("enonce_source").innerHTML, tinymce.get("enonce").getContent(), "enonce_diff");

			//question_preparatoire
			if (document.getElementById("question_preparatoire_source")) {
				document.querySelectorAll("#div_question_preparatoire_input .diff_dupliquer_item").forEach(element => {
					const champ = element.id.slice(0, -5);
					objItem.compareStrings(document.getElementById(champ + "_source").innerHTML, document.getElementById(champ).value, element.id);
				});
			}

			//question principale
			document.querySelectorAll("#div_question_principale_input .diff_dupliquer_item").forEach(element => {
				const champ = element.id.slice(0, -5);
				objItem.compareStrings(document.getElementById(champ + "_source").innerHTML, document.getElementById(champ).value, element.id);
			});

			//compare la justification
			objItem.compareStrings(document.getElementById("justification_source").innerHTML, tinymce.get("justification").getContent(), "justification_diff");

			//affiche les mots en double
			objItem.duplicateWords(php_to_js_vars.mots_communs);
		});

		//valide la création de l'exercice
		this.objCommons.bindEvent("valider", "click", () => objItem.create());
	}
	/**
	 * Page avec la liste des items
	 */
	async itemsListe() {

		//initialise le menu
		this.objMenu.items();

		//change le module
		this.objCommons.bindEvent("id_module", "change", (event) => {
			location.href = "../" + event.currentTarget.value + "/1";
		});

		//renvoie a la page sélectionnée
		this.objCommons.bindEvent("num_page", "change", (event) => {
			document.getElementById("search_plus_form").action = event.currentTarget.value;
			document.getElementById("search_plus_form").submit();
		});

		//recherche avancée
		this.objCommons.bindEvent("bouton_search_plus", "click", () => {
			const id_dialog = "dialog_search_plus";
			this.objDialog.setId(id_dialog);
			this.objDialog.show();
		});

		//valide la recherche
		this.objCommons.bindEvent("dialog_search_plus_valider", "click", () => {
			document.getElementById("search_plus_form").action = "1";
			document.getElementById("search_plus_form").submit();
		});

		//ferme le dialog
		this.objCommons.bindEvent("dialog_search_plus_annuler", "click", () => this.objDialog.hide());

		//annule une recherche
		this.objCommons.bindEvent("bouton_cancel_search", "click", () => {
			location.href = "1";
		});
	}
	/**
	 * Page avec le résumé des items
	 */
	async itemsResume() {

		//initialise le menu
		this.objMenu.items();

		//change le module
		this.objCommons.bindEvent("id_module", "change", (event) => {
			location.href = event.currentTarget.value;
		});

		//lance une recherche sur les types
		this.objCommons.bindEvent("rechercher_type", "keyup", (event) => {
			const _search_value = event.currentTarget.value;
			document.querySelectorAll(".grand_type_resume .div_titre b").forEach(element => {
				if (element.innerHTML.includes(_search_value)) {
					element.parentNode.parentNode.style.display = "block";
				} else {
					element.parentNode.parentNode.style.display = "none";
				}
			});
		});

		//ouvre les titlepane
		document.querySelectorAll(".grand_type_resume .div_titre").forEach(element => {
			this.objCommons.bindEvent(element.id, "click", (event) => {
				const id = event.currentTarget.id;
				const content_el = document.getElementById(id + "_content");
				if (content_el.style.display === "none") {
					content_el.style.display = "block";
					this.objCommons.setDisplay(id + "_resume", "none");
				} else {
					content_el.style.display = "none";
					this.objCommons.setDisplay(id + "_resume", "block");
				}
			});
		});

		//click sur le bouton tout ouvrir
		this.objCommons.bindEvent("bouton_tout_ouvrir", "click", () => {
			document.querySelectorAll(".grand_type_resume .div_titre").forEach(element => {
				const content_el = document.getElementById(element.id + "_content");
				if (content_el.style.display === "none") {
					content_el.style.display = "block";
					this.objCommons.setDisplay(element.id + "_resume", "none");
				} else {
					content_el.style.display = "none";
					this.objCommons.setDisplay(element.id + "_resume", "block");
				}
			});
		});

		//lien vers la création d'un item
		document.querySelectorAll('[name="creer_exercice"]').forEach(element => {
			element.addEventListener("click", (event) => {

				//récupère l'id module dans l'URL
				const parts = location.pathname.split('/').filter(Boolean);
				const idModule = parts[2];

				//renvoie vers la page de création
				location.href = "../creation/" + idModule + "?id_item_type=" + event.currentTarget.id.split("_")[2];
			});
		});
	}
	/**
	 * Page de révision des items
	 */
	async itemsRevision() {

		//importe les modules
		const [{default: Exercices}, {default: Item}, {default: LireCouleur}, {default: Mots}] = await Promise.all([
			import("./exercices"),
			import("./item"),
			import("./lireCouleur"),
			import("./mots")
		]);

		//register les classes
		this.appContext.register("objLireCouleur", new LireCouleur(this.appContext));
		this.appContext.register("objExercices", new Exercices(this.appContext));

		//création des objets
		const objExercices = this.appContext.get("objExercices");
		const objItem = new Item(this.appContext);
		const objMots = new Mots(this.appContext);

		//initialise le menu
		this.objMenu.items();

		//affiche les bonnes réponses
		objExercices.toggleBonnesRep(true);

		//boucle pour chaque clone
		if (document.getElementById("clones")) {
			document.getElementById("clones").querySelectorAll("a").forEach(clone => {
				this.objCommons.bindEvent(clone.id, "click", (event) => {
					location.href = event.currentTarget.id.split("_")[1];
				});
			});
		}

		//action sur le champ etat
		this.objCommons.bindEvent("etat", "change", (event) => {
			objItem.update("etat", event.currentTarget.value);
		});

		//action sur le bouton modifier
		if (document.getElementById("update_item")) {
			this.objCommons.bindEvent("update_item", "click", () => {
				this.objCommons.setDisplay("item_vue_eleve", "none");
				this.objCommons.setDisplay("form", "block");
			});
		}

		//action sur le bouton retour item vue eleve
		this.objCommons.bindEvent("retour_vue_eleve", "click", (event) => {
			this.objCommons.disableButton(event.currentTarget.id);
			location.reload();
		});

		//initialise le module tinymce
		if (php_to_js_vars.autorisations === "true") {
			objItem.initTinymce();
		} else {
			objItem.initTinymce(true);
		}

		//action sur le champ item_type
		this.objCommons.bindEvent("item_type", "change", (event) => {
			objItem.update("id_item_type", event.currentTarget.value);
			objItem.getType();
		});

		//recupere la regle et l'item exemple
		objItem.getType();

		//ajoute un mot cible
		this.objCommons.bindEvent("add_mot_cible", "click", () => objMots.addMotCible());

		//s'il y a des mots cibles
		if (php_to_js_vars.mots_cibles.length > 0) {
			Object.values(php_to_js_vars.mots_cibles).forEach(mot => {
				objMots.addMotCible(mot);
			});
		}

		//valide les modification sur le mot cible
		this.objCommons.bindEvent("valide_update_mots_cibles", "click", () => objItem.update("mots_cibles", objMots.getMotsCibles()));

		//valide les modification sur l'énoncé
		this.objCommons.bindEvent("valide_update_enonce", "click", () => {
			const content = tinymce.get("enonce").getContent();

			//s'il n'y a pas de mot bleu
			if (document.getElementById("consigne_mot_bleu") && (content.search("#0000ff") === -1 && content.search("rgb(0, 0, 255)") === -1)) {
				document.getElementById("error_enonce").innerHTML = "Vous devez spécifier un mot bleu !";
			} else {
				objItem.update("enonce", content);
			}
		});

		//action sur le champ traitement_crochets
		this.objCommons.bindEvent("traitement_crochets", "change", (event) => {
			objItem.update("traitement_crochets", event.currentTarget.value);
		});

		//action sur les boutons d'ajout de réponses
		this.objCommons.bindEvent("question_preparatoire_add_bonne_reponse", "click", () => objItem.addReponse("question_preparatoire", "bonne_reponse"));
		this.objCommons.bindEvent("question_preparatoire_add_mauvaise_reponse", "click", () => objItem.addReponse("question_preparatoire", "mauvaise_reponse"));

		//valide les modification sur la question preparatoire
		this.objCommons.bindEvent("valide_update_question_preparatoire", "click", () => objItem.update("question_preparatoire", ""));

		//action sur les boutons d'ajout de réponses
		this.objCommons.bindEvent("question_principale_add_bonne_reponse", "click", () => objItem.addReponse("question_principale", "bonne_reponse"));
		this.objCommons.bindEvent("question_principale_add_mauvaise_reponse", "click", () => objItem.addReponse("question_principale", "mauvaise_reponse"));

		//valide les modification sur la question principale
		this.objCommons.bindEvent("valide_update_question_principale", "click", () => objItem.update("question_principale", ""));

		//supprime une réponse
		document.querySelectorAll('[name="delete_reponse"]').forEach(element => {
			const id_reponse = element.id.replace("supprimer_", "");
			element.addEventListener("click", () => {
				objItem.deleteReponse(id_reponse);
			});
		});

		//case à cocher question_avant_enonce
		this.objCommons.bindEvent("question_avant_enonce", "change", (event) => {
			objItem.update("question_avant_enonce", event.currentTarget.checked);
		});

		//valide les modification sur la justification
		this.objCommons.bindEvent("valide_update_justification", "click", () => {
			const content = tinymce.get("justification").getContent();
			objItem.update("justification", content);
		});

		//supprime les commentaires
		document.querySelectorAll("#comments .icone-valide").forEach(element => {
			const id = element.dataset.id.split(",");
			element.addEventListener("click", () => {
				objItem.clotureCommentaire(id[0], id[2]);
			});
		});
		document.querySelectorAll("#comments .icone-trash").forEach(element => {
			element.addEventListener("click", () => {
				objItem.deleteCommentaire(element.dataset.id);
			});
		});

		//action sur le bouton bouton_enregistrer_commentaire
		this.objCommons.bindEvent("bouton_enregistrer_commentaire", "click", (event) => {
			this.objCommons.disableButton(event.currentTarget.id);
			objItem.newCommentaire(document.getElementById("nouveau_commentaire").value, true);
		});

		//action sur le champ comment
		this.objCommons.bindEvent("nouveau_commentaire", "keypress", (event) => {

			//appuie sur "enter"
			if (event.keyCode === 13) {
				objItem.newCommentaire(event.currentTarget.value, true);
				event.currentTarget.value = "";
				return false;
			}
		});

		//clic sur une étoile
		document.querySelectorAll('[name="rate"]').forEach(element => {
			element.addEventListener("click", (event) => {
				objItem.rate(event.currentTarget.value);
			});
		});

		//action sur le bouton precedent
		this.objCommons.bindEvent("precedent", "click", (event) => {
			this.objCommons.disableButton(event.currentTarget.id);
			objItem.get("prev");
		});

		//génère le select avec les ids items
		$.getJSON(php_to_js_vars.url + "api/store/ids_items", (data) => {
			const mySelect = $("#num_item").selectize({
				plugins: ["restore_on_backspace"],
				delimiter: " - ",
				persist: false,
				maxItems: 1,
				valueField: "id",
				labelField: "id",
				searchField: ["id"],
				options: data,
				onChange: function (value) {
					const item = this.options[value];
					location.href = item.id;
				}
			});

			//s'il y a bien un item affiché
			const divContenuItem = document.querySelector(".div_contenu_item");
			if (divContenuItem) {

				//récupère l'id de l'item affiché actuellement
				const currentIdItem = divContenuItem.dataset.idItem;
				if (currentIdItem) {

					//valeur par défaut
					mySelect[0].selectize.setValue(currentIdItem, true);
				}
			}
		});

		//action sur le bouton suivant
		this.objCommons.bindEvent("suivant", "click", (event) => {
			this.objCommons.disableButton(event.currentTarget.id);
			objItem.get("next");
		});

		//action sur le bouton dupliquer
		this.objCommons.bindEvent("bouton_dupliquer", "click", (event) => {
			this.objCommons.disableButton(event.currentTarget.id);
			const currentURL = location.href;
			location.href = currentURL.replace("revision", "duplication");
		});

		//action sur le bouton supprimer
		this.objCommons.bindEvent("delete_item", "click", () => objItem.dialogDelete());

		//action sur le bouton vocaliser
		this.objCommons.bindEvent("update_tts", "click", () => objItem.dialogVocaliser());

		//cache la div de loading
		document.querySelector(".div_contenu_item_loading").style.display = "none";
	}
	/**
	 * Page de confirmation d'une commande
	 */
	async licenceCommandeOk() {

		//initialise le menu
		this.objMenu.licence();

		//retour à la liste des commande
		this.objCommons.bindEvent("retour", "click", (event) => {
			this.objCommons.disableButton(event.currentTarget.id);
			if (php_to_js_vars.statut === "facturation" || php_to_js_vars.statut === "administrateur") {
				location.href = php_to_js_vars.url + "comptes/dossier";
			} else {
				location.href = "../gerer/last";
			}
		});
	}
	/**
	 * Page de commande de licences
	 */
	async licenceCommander() {

		//importe les modules
		const [{default: Commandes}] = await Promise.all([
			import("./commandes")
		]);

		//nouvel objet
		const objCommandes = new Commandes(this.appContext);

		//initialise le menu
		this.objMenu.licence();

		//initialise les titlepanes
		this.objCommons.initTitlePanes();

		//valide le formulaire de nombre de licences
		this.objCommons.bindEvent("check_nb_licences", "click", () => objCommandes.checkLicences());

		//génère le select communes
		const idCommune = document.getElementById("commune_etablissement").dataset.idCommune;
		this.objCommons.getCommunes(true, idCommune).then(() => {

			//action sur le bouton etablissement_avec_uai
			this.objCommons.bindEvent("etablissement_avec_uai", "change", (event) => {
				if (event.currentTarget.checked === true) {
					this.objCommons.updateOrganismeForm();
				}
			});

			//action sur le bouton etablissement_sans_uai
			this.objCommons.bindEvent("etablissement_sans_uai", "change", (event) => {
				if (event.currentTarget.checked === true) {
					this.objCommons.updateOrganismeForm();
				}
			});

			//action sur le code uai
			this.objCommons.bindEvent("code_uai", "keyup", (event) => {

				//ignore le shift
				if (event.keyCode !== 16) {
					this.objCommons.getEtablissement();
				}
			});

			//génère le select pays
			const idPays = document.getElementById("pays_etablissement").dataset.idPays;
			this.objCommons.getPays(true, idPays);

			//met a jour le prix total
			this.objCommons.bindEvent("nb_licences", "change", () => this.objCommons.updatePrix());

			//au moment du choix du payeur
			this.objCommons.bindEvent("type_etablissement", "change", () => {
				this.objCommons.updateOrganismeForm();
			});

			//valide le formulaire de l'organisme payeur
			this.objCommons.bindEvent("check_payeur", "click", () => objCommandes.checkPayeur());

			//validation du formulaire de nouvelle commande
			this.objCommons.bindEvent("valide_new_commande", "click", () => {
				if (php_to_js_vars.statut === "orthophoniste") {
					objCommandes.nouvelleCommande();
				} else {
					objCommandes.confirmPayeur();
				}
			});

			//annulation du formulaire de nouvelle commande
			this.objCommons.bindEvent("cancel_new_commande", "click", (event) => {
				this.objCommons.disableButton(event.currentTarget.id);
				history.back();
			});
		});
	}
	/**
	 * Page de sélection des licences pour le GAR
	 */
	async licenceGar() {

		//importe les modules
		const [{default: Gar}] = await Promise.all([
			import("./gar")
		]);

		//nouvel objet
		const objGar = new Gar(this.appContext);

		//initialise le menu
		this.objMenu.licence();

		//validation du formulaire
		this.objCommons.bindEvent("valide_licences_gar", "click", () => {
			const form = document.getElementById("form_licences_gar");
			if (form.querySelectorAll(":invalid").length === 0) {
				objGar.dialogConfirm();
			} else {
				this.objCommons.isInvalid("nb_licences_gar");
			}
		});

		//annulation du formulaire
		this.objCommons.bindEvent("cancel_licences_gar", "click", (event) => {
			this.objCommons.disableButton(event.currentTarget.id);
			location.href = "gerer/last";
		});

		//retour
		this.objCommons.bindEvent("retour", "click", (event) => {
			this.objCommons.disableButton(event.currentTarget.id);
			location.href = "gerer/last";
		});
	}
	/**
	 * Page de gestion de la licence
	 */
	async licenceGerer() {

		//importe les modules
		const [{default: Commandes}, {default: Gar}, {default: Transferts}] = await Promise.all([
			import("./commandes"),
			import("./gar"),
			import("./transferts")
		]);

		//nouvel objet
		const objCommandes = new Commandes(this.appContext);
		const objGar = new Gar(this.appContext);
		const objTransferts = new Transferts(this.appContext);

		//lien GAR
		if (document.getElementById("lien_gar")) {
			this.objCommons.bindEvent("lien_gar", "click", () => {
				location.href = "../gar";
			});
		}

		//suppression des abonnements
		if (document.getElementById("bouton_delete_abonnement")) {
			this.objCommons.bindEvent("bouton_delete_abonnement", "click", () => objGar.dialogDeleteAboGar());
		}

		//ouvre le rib
		this.objCommons.bindEvent("bouton_rib", "click", () => {
			window.open("../../documents/document/rib");
		});

		//ouvre le dialog de création d'un devis
		this.objCommons.bindEvent("bouton_creer_devis", "click", (event) => {
			this.objCommons.disableButton(event.currentTarget.id);
			location.href = "../devis";
		});

		//affiche le formulaire de nouvelle commande
		this.objCommons.bindEvent("bouton_nouvelle_commande", "click", (event) => {
			this.objCommons.disableButton(event.currentTarget.id);
			location.href = "../commander";
		});

		//boucle pour chaque comande
		document.querySelectorAll("#tableau_licence tbody>tr").forEach(commande => {
			const id_commande = commande.id.split("_")[1];

			//récupère le bdc
			const donwload_bdc = commande.querySelector('[name="download_bdc"]');
			if (donwload_bdc) {
				donwload_bdc.addEventListener("click", () => {
					window.open("../bonDeCommande/" + id_commande);
				});
			}

			//dépose le bdc
			const depot_bdc = commande.querySelector('[name="depot_bdc"]');
			if (depot_bdc) {
				depot_bdc.addEventListener("click", () => objCommandes.dialogDepotBonDeCommande(id_commande));
			}

			//annule la commande
			const icone_trash = commande.querySelector(".icone-trash");
			if (icone_trash) {
				icone_trash.addEventListener("click", () => objCommandes.dialogCancel(id_commande));
			}
		});

		//rend le tableau triable par colonne
		this.objCommons.sortTable(document.getElementById("tableau_licence"));

		//renvoie sur la page de transfert
		this.objCommons.bindEvent("bouton_nouveau_transfert", "click", (event) => {
			this.objCommons.disableButton(event.currentTarget.id);
			location.href = "../transfert";
		});

		//renvoie sur la page de transfert
		this.objCommons.bindEvent("bouton_utiliser_transfert", "click", () => objTransferts.dialogUtiliserTransfert());

		//boucle pour chaque formulaire de la page
		document.getElementById("tableau_transferts").querySelectorAll("tbody tr").forEach(tr => {
			const _k = tr.id.split("_")[1];

			//email du transfert
			this.objCommons.bindEvent("email_transfert_" + _k, "click", () => objTransferts.dialogEmailTransfert(_k));

			//suppression du transfert
			this.objCommons.bindEvent("delete_transfert_" + _k, "click", () => objTransferts.dialogDeleteTransfert(_k));
		});
	}
	/**
	 * Page de commande de licences
	 */
	async licenceModifier() {
		this.licenceCommander();
	}
	/**
	 * Page de transfert de licences
	 */
	async licenceTransfert() {

		//importe les modules
		const [{default: Transferts}] = await Promise.all([
			import("./transferts")
		]);

		//nouvel objet
		const objTransferts = new Transferts(this.appContext);

		//initialise le menu
		this.objMenu.licence();

		//génère le select communes
		this.objCommons.getCommunes(true);

		//action sur le code uai
		this.objCommons.bindEvent("code_uai", "keyup", (event) => {

			//ignore le shift
			if (event.keyCode !== 16) {
				this.objCommons.getEtablissement();
			}
		});

		//validation du formulaire de nouveau transfert
		this.objCommons.bindEvent("valide_nouveau_transfert", "click", () => {
			const form = document.getElementById("form_transfert");
			if (form.querySelectorAll(":invalid").length === 0) {

				//si un établissement est sélectionné
				if (document.getElementById("nom_etablissement").value !== "") {
					objTransferts.dialogConfirmTransfert();
				} else {
					objTransferts.nouveauTransfert();
				}
			} else {
				this.objCommons.isInvalid("nb_licences_transfert");
			}
		});

		//annulation du formulaire de nouveau transfert
		this.objCommons.bindEvent("cancel_nouveau_transfert", "click", (event) => {
			this.objCommons.disableButton(event.currentTarget.id);
			location.href = "gerer/last";
		});
	}
	/**
	 * Page de gestion des modules
	 */
	async modulesGerer() {

		//importe les modules
		const [{default: Graphiques}, {default: Modules}, {default: Resultats}] = await Promise.all([
			import("./graphiques"),
			import("./modules"),
			import("./resultats")
		]);

		//nouvel objet
		const objGraphiques = new Graphiques(this.appContext);
		const objModules = new Modules(this.appContext);
		const objResultats = new Resultats(this.appContext);

		//initialise les tinymce
		objModules.initTynimce();

		//change le module
		this.objCommons.bindEvent("id_module", "change", (event) => {
			location.href = event.currentTarget.value;
		});

		//changement de couleur
		this.objCommons.bindEvent("couleur_module", "change", (event) => {
			const value = event.currentTarget.value;
			document.getElementById("id_module").className = "texte_module_" + value;
			document.body.className = "interface_" + value;
			objModules.update("couleur", value);
		});

		//affichage de l'onglet
		document.querySelectorAll(".fond_onglets div").forEach(element => {
			this.objCommons.bindEvent(element.id, "click", (event) => {
				this.objCommons.switchOnglet(event.currentTarget.id);
				if (event.currentTarget.id === "chart_grands_types") {
					objGraphiques.moduleGrandsTypes();
				}
				if (event.currentTarget.id === "chart_sous_types") {
					objGraphiques.moduleSousTypes();
				}
				if (event.currentTarget.id === "chart_evals_niveau") {
					objGraphiques.moduleEvaluationsNiveau();
				}
				if (event.currentTarget.id === "chart_evals_numero") {
					objGraphiques.moduleEvaluationsNumero();
				}
				if (event.currentTarget.id === "chart_type_passations") {
					objGraphiques.moduleTypePassations();
				}
			});
		});

		//récupère les graphiques
		objGraphiques.moduleItems();

		//action sur le menu reperes
		this.objCommons.bindEvent("reperes_graphiques", "click", (event) => {
			objResultats.showRepere(event.currentTarget.value);
		});

		//clique sur la présentation
		this.objCommons.bindEvent("div_presentation", "click", (event) => {
			event.currentTarget.style.display = "none";
			this.objCommons.setDisplay("input_presentation", "block");
		});

		//clique sur la validation de la présentation
		this.objCommons.bindEvent("valide_presentation", "click", (event) => {
			this.objCommons.disableButton(event.currentTarget.id);
			objModules.update("presentation", tinymce.get("presentation").getContent());
		});

		//clique sur la validation de la présentation
		this.objCommons.bindEvent("cancel_presentation", "click", () => {
			this.objCommons.setDisplay("input_presentation", "none");
			this.objCommons.setDisplay("div_presentation", "block");
		});

		//changement de borne
		this.objCommons.bindEvent("borne", "change", (event) => {
			objModules.update("borne", Math.abs(event.currentTarget.value));
		});

		//changement de mot cible
		this.objCommons.bindEvent("mot_cible", "change", (event) => {
			objModules.update("mot_cible", event.currentTarget.checked);
		});

		//changement de mot bleu
		this.objCommons.bindEvent("mot_bleu", "change", (event) => {
			objModules.update("mot_bleu", event.currentTarget.checked);
		});

		//changement de question prep
		this.objCommons.bindEvent("question_preparatoire", "change", (event) => {
			objModules.update("question_preparatoire", event.currentTarget.checked);
		});

		//changement des aides prealables
		this.objCommons.bindEvent("aide_prealable", "change", (event) => {
			objModules.update("aide_prealable", event.currentTarget.checked);
		});

		//changement des explications détaillées
		this.objCommons.bindEvent("explication_detaillee", "change", (event) => {
			objModules.update("explication_detaillee", event.currentTarget.checked);
		});
	}
	/**
	 * Page de création d'un mot
	 */
	async motsCreerMot() {

		//importe les modules
		const [{default: Mots}] = await Promise.all([
			import("./mots")
		]);

		//nouvel objet
		const objMots = new Mots(this.appContext);

		//initialise le menu
		this.objMenu.mots();

		//change le module
		this.objCommons.bindEvent("nature", "change", () => objMots.updateNature());

		//récupère les verbes
		objMots.getVerbes();

		//change les pp sujets
		document.querySelectorAll('input[name="pp_sujets"]').forEach(input => {
			input.addEventListener("change", () => objMots.updateNature());
		});

		//change le mot
		this.objCommons.bindEvent("mot_cible", "change", () => objMots.updateNature());

		//création d'une définition
		this.objCommons.bindEvent("bouton_creer_definition", "click", () => objMots.createDefinition());

		//suppression des definitions
		document.querySelectorAll("#liste_definitions tbody>tr").forEach(definition => {
			const id_definition = definition.id.split("_")[1];
			const delete_definition = definition.querySelector(".icone-trash");
			if (delete_definition) {
				delete_definition.addEventListener("click", () => objMots.dialogDeleteDefinition(id_definition));
			}
		});

		// Appliquer l'ajustement à tous les <textarea> lors de la saisie
		document.querySelectorAll("textarea").forEach(textarea => {
			textarea.addEventListener("input", (event) => {
				objMots.autoResizeTextarea(event.currentTarget);
			});
		});

		//resize les textarea au chargement
		const textareas = document.querySelectorAll("textarea");
		textareas.forEach(textarea => {
			objMots.autoResizeTextarea(textarea);
		});

		//valide les modifications
		this.objCommons.bindEvent("bouton_valider", "click", () => objMots.update());
	}
	/**
	 * Page avec la liste des mots cible
	 */
	async motsListe() {

		//initialise le menu
		this.objMenu.mots();

		//renvoie a la page sélectionnée
		this.objCommons.bindEvent("num_page", "change", (event) => {
			document.getElementById("search_plus_form").action = event.currentTarget.value;
			document.getElementById("search_plus_form").submit();
		});

		//création d'un mot
		this.objCommons.bindEvent("bouton_creer_mot", "click", () => {
			location.href = "../creerMot";
		});

		//recherche avancée
		this.objCommons.bindEvent("bouton_search_plus", "click", () => {
			const id_dialog = "dialog_search_plus";
			this.objDialog.setId(id_dialog);
			this.objDialog.show();
		});

		//valide la recherche
		this.objCommons.bindEvent("dialog_search_plus_valider", "click", () => {
			document.getElementById("search_plus_form").action = "1";
			document.getElementById("search_plus_form").submit();
		});

		//ferme le dialog
		this.objCommons.bindEvent("dialog_search_plus_annuler", "click", () => this.objDialog.hide());

		//annule une recherche
		this.objCommons.bindEvent("bouton_cancel_search", "click", () => {
			location.href = "1";
		});

		//boucle pour chaque formulaire de la page
		document.querySelectorAll("#tableau_mots tbody tr").forEach(tr => {
			const _k = tr.id.split("_")[1];

			//actions sur les icones modifier
			this.objCommons.bindEvent("modifier_" + _k, "click", () => {
				window.open("../modifier/" + _k);
			});
		});
	}
	/**
	 * Page de modification d'un mot
	 */
	async motsModifierMot() {
		this.motsCreerMot();
	}
	/**
	 * Page avec la liste des natures
	 */
	async motsNatures() {

		//initialise le menu
		this.objMenu.mots();

		//renvoie a la page sélectionnée
		this.objCommons.bindEvent("num_page", "change", (event) => {
			location.href = event.currentTarget.value;
		});
	}
	/**
	 * Page avec le listing des patients
	 */
	async orthophonistePatients() {

		//importe les modules
		const [{default: Patients}] = await Promise.all([
			import("./patients")
		]);

		//register les classes
		this.appContext.register("objPatients", new Patients(this.appContext));

		//création des objets
		const objPatients = this.appContext.get("objPatients");

		//action sur le bouton_add_ligne_patient
		this.objCommons.bindEvent("bouton_create_patient", "click", () => objPatients.openDialog(null));

		//affiche que les connectés
		this.objCommons.bindEvent("case_afficher_tout", "click", (event) => {
			const icon = event.currentTarget.querySelector("div");

			//Toggle the button state
			event.currentTarget.classList.toggle("active");

			// Toggle the icon based on the button state
			if (event.currentTarget.classList.contains("active")) {
				icon.classList.remove("icone-show-all");
				icon.classList.add("icone-show-all-vert");
				let _nb_patients = 0;

				//affiche les patients
				document.querySelectorAll(".form_patient").forEach(element => {
					if (element.classList.contains("patient_supprime")) {
						if (document.getElementById("case_comptes_supprimes").classList.contains("active")) {
							element.style.display = "table-row";
							_nb_patients++;
						} else {
							element.style.display = "none";
						}
					} else {
						element.style.display = "table-row";
						_nb_patients++;
					}
				});

				//si des patients ont été affichés
				if (_nb_patients > 0) {
					this.objCommons.setDisplay("search_patient", "none");
				}
			} else {
				icon.classList.remove("icone-show-all-vert");
				icon.classList.add("icone-show-all");

				//cache les patients
				document.querySelectorAll(".form_patient").forEach(element => {
					element.style.display = "none";
				});
			}
		});

		//affiche que les connectés
		this.objCommons.bindEvent("case_comptes_supprimes", "click", (event) => {
			if (document.getElementById("search_patient").style.display === "none") {
				const icon = event.currentTarget.querySelector("div");

				//Toggle the button state
				event.currentTarget.classList.toggle("active");

				// Toggle the icon based on the button state
				if (event.currentTarget.classList.contains("active")) {
					icon.classList.remove("icone-trash");
					icon.classList.add("icone-trash-vert");

					//affiche les patients
					document.querySelectorAll(".form_patient").forEach(element => {
						if (element.classList.contains("patient_supprime")) {
							if (document.getElementById("case_comptes_supprimes").classList.contains("active")) {
								element.style.display = "table-row";
							} else {
								element.style.display = "none";
							}
						}
					});
				} else {
					icon.classList.remove("icone-trash-vert");
					icon.classList.add("icone-trash");

					//cache les patients
					document.querySelectorAll(".form_patient").forEach(element => {
						if (element.classList.contains("patient_supprime")) {
							element.style.display = "none";
						}
					});
				}
			}
		});

		//champ de recherche des patients
		this.objCommons.bindEvent("mots", "keyup", () => objPatients.search());

		//rend le tableau triable par colonne
		this.objCommons.sortTable(document.getElementById("tableau_patients"));

		//boucle pour chaque formulaire de la page
		document.querySelectorAll("#tableau_patients tbody tr").forEach(tr => {
			const _k = tr.id.split("_")[1];

			//actions sur les fiches
			this.objCommons.bindEvent("dossier_" + _k, "click", () => {
				location.href = "../patients/dossier/" + _k;
			});

			//actions sur les icones modifier
			this.objCommons.bindEvent("modifier_" + _k, "click", () => objPatients.openDialog(_k));

			//actions sur les icones supprimer
			this.objCommons.bindEvent("supprimer_" + _k, "click", () => objPatients.dialogDelete(_k));

			//actions sur les icones reactriver
			this.objCommons.bindEvent("reactiver_" + _k, "click", () => objPatients.reactiver(_k));
		});
	}
	/**
	 * Page de details d'une séance
	 */
	async patientsDetailSeance() {

		//initialise le menu
		this.objMenu.orthophoniste();
	}
	/**
	 * Page de séance à domicile pour un patient
	 */
	async patientsDomicile() {

		//importe les modules
		const [{default: Exercices}, {default: LireCouleur}, {default: Patients}] = await Promise.all([
			import("./exercices"),
			import("./lireCouleur"),
			import("./patients")
		]);

		//register les classes
		this.appContext.register("objLireCouleur", new LireCouleur(this.appContext));
		this.appContext.register("objExercices", new Exercices(this.appContext));
		this.appContext.register("objPatients", new Patients(this.appContext));

		//création des objets
		const objExercices = this.appContext.get("objExercices");
		const objPatients = this.appContext.get("objPatients");

		//initialise le menu
		this.objMenu.orthophoniste();

		//action sur le bouton de nouvelle
		this.objCommons.bindEvent("nouvelle_seance_domicile", "click", (event) => {
			this.objCommons.disableButton(event.currentTarget.id);
			objPatients.checkDomicile();
		});

		//actions toggleButtons
		this.objCommons.toggleButton("mots_bleus");
		this.objCommons.toggleButton("question_preparatoire");
		this.objCommons.toggleButton("lecture_audio");
		this.objCommons.toggleButton("score");
		this.objCommons.toggleButton("avancement");

		//action sur le bouton de validation
		this.objCommons.bindEvent("valider_seance_domicile", "click", (event) => {
			this.objCommons.disableButton(event.currentTarget.id);
			objPatients.createDomicile();
		});

		//action sur le bouton annulation
		this.objCommons.bindEvent("annuler_seance_domicile", "click", () => {
			this.objCommons.setDisplay("seance_en_cours", "block");
			this.objCommons.setDisplay("nouvelle_seance", "none");
		});

		//action sur le lien guide connexion
		this.objCommons.bindEvent("lien_guide_connexion", "click", () => {
			window.open("../../documents/guidePatient/" + objPatients.currentIdPatient);
		});

		//listener sur les cases des items
		document.querySelector(".liste_items").addEventListener("click", (e) => {
			const el = e.target.closest("[id^='num_item_']");
			if (!el) {
				return;
			}

			const idItem = el.id.replace("num_item_", "");
			objPatients.showItem(Number(idItem));
		});

		//action sur le bouton commenter item
		if (document.getElementById("bouton_commenter_item")) {
			this.objCommons.bindEvent("bouton_commenter_item", "click", () => {
				objExercices.dialogCommentaire();
			});

			//action sur le bouton fermer item
			this.objCommons.bindEvent("fermer_show_item", "click", () => {
				this.objCommons.setDisplay("show_item", "none");
				document.querySelectorAll(".case_item").forEach(case_item => {
					case_item.classList.remove("case_item_selected");
				});
			});

			//action sur le bouton replace_item
			this.objCommons.bindEvent("replace_item", "click", () => objPatients.replaceItem());
		}

		//rafraichis les cases de couleurs
		objPatients.refreshTableauItems();

		//subscribe au channel
		this.objRatchet.sendCommand({
			command: "subscribe",
			command: "subscribe",
			token: php_to_js_vars.token_subscribe
		});
	}
	/**
	 * Page de dossier d'un patient
	 */
	async patientsDossier() {

		//importe les modules
		const [{default: Patients}, {default: Resultats}] = await Promise.all([
			import("./patients"),
			import("./resultats")
		]);

		//register les classes
		this.appContext.register("objPatients", new Patients(this.appContext));

		//création des objets
		const objPatients = this.appContext.get("objPatients");
		const objResultats = new Resultats(this.appContext);

		//initialise le menu
		this.objMenu.orthophoniste();

		//action sur le bouton exercices
		this.objCommons.bindEvent("bouton_exercices", "click", (event) => {
			this.objCommons.disableButton(event.currentTarget.id);
			const currentURL = location.href;
			location.href = currentURL.replace("dossier", "exercices");
		});

		//action sur le bouton exercices
		this.objCommons.bindEvent("bouton_seance_domicile", "click", (event) => {
			this.objCommons.disableButton(event.currentTarget.id);
			const currentURL = location.href;
			location.href = currentURL.replace("dossier", "domicile");
		});

		//action sur le bouton Télécharger
		this.objCommons.bindEvent("bouton_telecharger", "click", (event) => {
			this.objCommons.disableButton(event.currentTarget.id);
			objResultats.getPdf("patient");
		});

		//action sur le bouton notes
		this.objCommons.bindEvent("bouton_notes", "click", () => objPatients.dialogNotes());

		//action sur le afficher seances
		this.objCommons.bindEvent("afficher_seances", "change", () => {
			const elements = document.querySelectorAll("#liste_seances_patient > div");
			elements.forEach(element => {

				//si c'est que les 8 dernières
				if (document.getElementById("afficher_seances").value === "dernieres_seances") {
					const num_seance = element.id.split("_")[1];
					if (num_seance < elements.length - 7) {
						element.style.display = "none";
					}
				} else {
					element.style.display = "block";
				}
			});
		});

		//action sur le menu reperes
		this.objCommons.bindEvent("reperes_graphiques", "click", (event) => {
			objResultats.showRepere(event.currentTarget.value);
			objPatients.updateNotes();
		});

		//affiche les notes du patients
		objPatients.updateNotes();

		//scroll en bas de la div
		const objDiv = document.getElementById("liste_seances_patient");
		objDiv.scrollTop = objDiv.scrollHeight;
	}
	/**
	 * Page d'exercice d'un patient
	 */
	async patientsExercices() {

		//importe les modules
		const [{default: Exercices}, {default: LireCouleur}, {default: Passations}, {default: Patients}] = await Promise.all([
			import("./exercices"),
			import("./lireCouleur"),
			import("./passations"),
			import("./patients")
		]);

		//register les classes
		this.appContext.register("objLireCouleur", new LireCouleur(this.appContext));
		this.appContext.register("objExercices", new Exercices(this.appContext));
		this.appContext.register("objPassations", new Passations(this.appContext));
		this.appContext.register("objPatients", new Patients(this.appContext));

		//création des objets
		const objLireCouleur = this.appContext.get("objLireCouleur");
		const objExercices = this.appContext.get("objExercices");
		const objPassations = this.appContext.get("objPassations");
		const objPatients = this.appContext.get("objPatients");

		//initialise le menu
		this.objMenu.orthophoniste();

		//action sur le bouton last_item
		this.objCommons.bindEvent("bouton_last_item", "click", () => {
			document.querySelector(".div_contenu_item").style.display = "none";
			this.objCommons.setDisplay("boutons_item_en_cours", "none");
			this.objCommons.setDisplay("div_item_precedent", "block");
			this.objCommons.setDisplay("boutons_item_precedent", "flex");
		});

		//action sur le bouton retour
		this.objCommons.bindEvent("bouton_retour", "click", () => {
			document.querySelector(".div_contenu_item").style.display = "block";
			this.objCommons.setDisplay("boutons_item_en_cours", "grid");
			this.objCommons.setDisplay("div_item_precedent", "none");
			this.objCommons.setDisplay("boutons_item_precedent", "none");
		});

		//action sur le bouton new_item
		this.objCommons.bindEvent("bouton_new_item", "click", () => objPatients.passerExercice());

		//action sur le bouton get_clone
		this.objCommons.bindEvent("bouton_get_clone", "click", () => objPatients.getClone());

		//action sur les bouton_valider_reponse
		this.objCommons.bindEvent("bouton_valider_reponse", "click", () => objPassations.repondrePatient(false));
		this.objCommons.bindEvent("bouton_valider_reponse_aide", "click", () => objPassations.repondrePatient(true));

		//action sur le bouton_question_suivante
		this.objCommons.bindEvent("bouton_question_suivante", "click", (event) => {
			this.objCommons.disableButton(event.currentTarget.id);
			location.reload();
		});

		//action sur le bouton commenter item
		this.objCommons.bindEvent("bouton_commenter_item", "click", () => {
			objExercices.dialogCommentaire();
		});

		//changement du mode
		this.objCommons.bindEvent("mode", "change", () => objPatients.changeNiveau());

		//action sur le bouton feedback
		this.objCommons.bindEvent("feedback_seance", "change", (event) => {
			objPatients.changeIndices("feedback", event.currentTarget.value);
		});

		//bouton score
		this.objCommons.toggleButton("score");
		this.objCommons.bindEvent("score", "click", (event) => {
			objPatients.changeIndices("score", document.querySelector("#" + event.currentTarget.id + " span").classList.contains("icone-valide"));
		});

		//action sur le bouton timer
		this.objCommons.bindEvent("create_timer", "click", () => objPatients.createTimer());

		//action sur le bouton timer
		this.objCommons.bindEvent("timer", "click", () => objPatients.createTimer());

		//si le timer était déjà commencé
		if (sessionStorage.getItem("timer_radius_" + objPatients.currentIdPatient)) {
			if (parseInt(sessionStorage.getItem("timer_radius_" + objPatients.currentIdPatient)) !== 0) {
				objPatients.animateTimer();
			}
		}

		//action sur le bouton quitter
		this.objCommons.bindEvent("bouton_quitter", "click", (event) => {
			this.objCommons.disableButton(event.currentTarget.id);
			location.href = "../dossier/" + objPatients.currentIdPatient;
		});

		//changement du niveau
		this.objCommons.bindEvent("niveau", "change", () => objPatients.changeNiveau());

		//wordcount par defaut
		document.getElementById("word_count").value = php_to_js_vars.affichage.word_count;

		//changement du word_count
		this.objCommons.bindEvent("word_count", "change", (event) => {
			objPatients.changeWordCount(event.currentTarget.value);
		});

		//action sur le bouton types
		this.objCommons.bindEvent("types", "click", () => {
			this.objDialog.setId("dialog_types");
			this.objDialog.show();
		});

		//action sur le bouton valider types d'exercices
		this.objCommons.bindEvent("dialog_types_valider", "click", (event) => {
			this.objCommons.disableButton(event.currentTarget.id);
			objPatients.saveTypes();
		});

		//action sur le bouton valider types d'exercices
		this.objCommons.bindEvent("dialog_types_annuler", "click", () => this.objDialog.hide());

		//bouton mots_bleus
		this.objCommons.toggleButton("mots_bleus");
		this.objCommons.bindEvent("mots_bleus", "click", (event) => {
			objPatients.changeIndices("mots_bleus", document.querySelector("#" + event.currentTarget.id + " span").classList.contains("icone-valide"));
		});

		//bouton mots_bleus
		this.objCommons.toggleButton("add_question_preparatoire");
		this.objCommons.bindEvent("add_question_preparatoire", "click", (event) => {
			objPatients.changeIndices("question_preparatoire", document.querySelector("#" + event.currentTarget.id + " span").classList.contains("icone-valide"));
		});

		//bouton affichage_sequentiel
		this.objCommons.toggleButton("affichage_sequentiel");
		this.objCommons.bindEvent("affichage_sequentiel", "click", (event) => {
			objPatients.changeIndices("affichage_sequentiel", document.querySelector("#" + event.currentTarget.id + " span").classList.contains("icone-valide"));
		});

		//possibilité de sélectionner les mots bleus
		objLireCouleur.selectableMotsEnonce = true;

		//scroll jusqu'au menu
		document.getElementById("menu").scrollIntoView();
	}
	/**
	 * Page de séance à domicile
	 */
	async patientSeance() {

		//importe les modules
		const [{default: Exercices}, {default: LireCouleur}, {default: Passations}] = await Promise.all([
			import("./exercices"),
			import("./lireCouleur"),
			import("./passations")
		]);

		//register les classes
		this.appContext.register("objLireCouleur", new LireCouleur(this.appContext));
		this.appContext.register("objExercices", new Exercices(this.appContext));
		this.appContext.register("objPassations", new Passations(this.appContext));

		//création des objets
		const objPassations = this.appContext.get("objPassations");

		//vérifie la réponse du patient
		this.objCommons.bindEvent("bouton_valider_reponse", "click", () => objPassations.repondrePatient(false));

		//passe à la question suivante
		this.objCommons.bindEvent("bouton_question_suivante", "click", (event) => {
			this.objCommons.disableButton(event.currentTarget.id);
			location.reload();
		});

		//regarde s'il y a une consigne
		if (php_to_js_vars.consigne != null) {
			objPassations.dialogConsigne();
		}
	}
	/**
	 * Page d'accueil
	 */
	async presentationAccueil() {

		//bouton presentation enseignant
		this.objCommons.bindEvent("diaporama_enseignant", "click", () => {
			this.objCommons.saveCookie("enseignant", "documents/diaporama/enseignant");
		});

		//bouton manuel enseignant
		this.objCommons.bindEvent("manuel_enseignant", "click", () => {
			this.objCommons.saveCookie("enseignant", "documents/manuel/enseignant");
		});

		//bouton tester enseignant
		this.objCommons.bindEvent("tester_enseignant", "click", () => {
			this.objCommons.saveCookie("enseignant", "inscription/test");
		});

		//bouton presentation orthophoniste
		this.objCommons.bindEvent("diaporama_orthophoniste", "click", () => {
			this.objCommons.saveCookie("orthophoniste", "documents/diaporama/orthophoniste");
		});

		//bouton manuel orthophoniste
		this.objCommons.bindEvent("manuel_orthophoniste", "click", () => {
			this.objCommons.saveCookie("orthophoniste", "documents/manuel/orthophoniste");
		});

		//bouton tester orthophoniste
		this.objCommons.bindEvent("tester_orthophoniste", "click", () => {
			this.objCommons.saveCookie("orthophoniste", "inscription/orthophoniste");
		});

		//bouton acces enseignant
		this.objCommons.bindEvent("acces_enseignant", "click", () => {
			this.objCommons.saveCookie("enseignant", "connexion/utilisateur");
		});

		//bouton acces eleve
		this.objCommons.bindEvent("acces_eleve", "click", () => {
			location.href = php_to_js_vars.url + "connexion/eleve";
		});

		//bouton acces ortho
		this.objCommons.bindEvent("acces_ortho", "click", () => {
			this.objCommons.saveCookie("orthophoniste", "connexion/utilisateur");
		});

		//bouton acces patient
		this.objCommons.bindEvent("acces_patient", "click", () => {
			location.href = php_to_js_vars.url + "connexion/patient";
		});

		//bouton tarif
		this.objCommons.bindEvent("voir_tarifs", "click", () => {
			location.href = php_to_js_vars.url + "presentation/tarif#tarifs";
		});

		//bouton devis
		this.objCommons.bindEvent("devis", "click", () => {
			location.href = php_to_js_vars.url + "inscription/devis";
		});

		//bouton tarif
		this.objCommons.bindEvent("commande_publique", "click", () => {
			location.href = php_to_js_vars.url + "inscription/organismePublic";
		});

		//bouton vidéos
		this.objCommons.bindEvent("video_presentation", "click", () => {
			window.open(php_to_js_vars.url + "documents/manuel/enseignant#8.1", "_blank");
		});
	}
	/**
	 * Page avec la carte de répartition
	 */
	async presentationCarte() {

		//importe les modules
		const [{default: Carte}] = await Promise.all([
			import("./carte")
		]);

		//nouvel objet
		const objCarte = new Carte(this.appContext);

		//Creation de la carte
		objCarte.create();
	}
	/**
	 * Page avec la justif du tarif
	 */
	async presentationTarif() {
		if (location.hash) {
			const target = location.hash;
			window.scrollTop = document.querySelector(target).offsetTop;
		}
	}
	/**
	 * Page avec les résultats d'un groupe
	 */
	async resultatsVoir() {

		//importe les modules
		const [{default: Resultats}, {default: Tchat}] = await Promise.all([
			import("./resultats"),
			import("./tchat")
		]);

		//s'il faut initialiser le tchat
		if (php_to_js_vars.statut !== "etablissement" && php_to_js_vars.statut !== "administrateur") {

			//register les classes
			this.appContext.register("objTchat", new Tchat(this.appContext));
		}

		//nouvel objet
		const objResultats = new Resultats(this.appContext);

		//initialise le menu
		if (php_to_js_vars.statut === "etablissement" || php_to_js_vars.statut === "administrateur") {
			this.objMenu.classes();
		} else {
			this.objMenu.groupes();
		}

		//initialise les ongles
		objResultats.initOnglets();

		//action sur le reperes
		this.objCommons.bindEvent("reperes_graphiques", "change", (event) => {
			objResultats.showRepere(event.currentTarget.value);
		});

		//action sur le tri des résultats
		this.objCommons.bindEvent("tri_resultats", "change", () => objResultats.trier());

		//action sur le bouton Télécharger
		this.objCommons.bindEvent("bouton_telecharger_groupe", "click", (event) => {
			this.objCommons.disableButton(event.currentTarget.id);
			objResultats.getPdf("groupe");
		});

		//action sur le bouton télécharger
		this.objCommons.bindEvent("bouton_telecharger_eleves", "click", () => objResultats.dialogTelechargement());
	}
	/**
	 * Page avec les statistiques de la bdd
	 */
	async statistiquesVoir() {

		//importe les modules
		const [{default: Graphiques}] = await Promise.all([
			import("./graphiques")
		]);

		//nouvel objet
		const objGraphiques = new Graphiques(this.appContext);

		//change le module
		this.objCommons.bindEvent("module_selectionne", "change", (event) => {
			location.href = event.currentTarget.value;
		});

		//lance les fonctions de recuperation des donnees
		objGraphiques.connexions();
		setTimeout(() => {
			objGraphiques.passations();
		}, 500);
		setTimeout(() => {
			objGraphiques.statsPassations();
		}, 1000);
	}
	/**
	 * Page d'accueil des utilisateurs
	 */
	async utilisateurAccueil() {

		//importe les modules
		const [{default: Rubriques}, {default: Tchat}] = await Promise.all([
			import("./rubriques"),
			import("./tchat")
		]);

		//register les classes
		this.appContext.register("objTchat", new Tchat(this.appContext));

		//création des objets
		const objRubriques = new Rubriques();

		//lien pour passer en mode enseignant
		this.objCommons.bindEvent("switch_mode", "click", (event) => {
			this.objCommons.disableButton(event.currentTarget.id);

			//envoie la requete au serveur pour changer de mode
			$.ajax({
				type: "GET",
				url: php_to_js_vars.url + "utilisateur/switchMode",
				cache: false
			}).done(() => {
				location.reload();
			});
		});

		//actions sur les rubriques
		document.querySelectorAll(".grid_rubriques .div_bottom_container").forEach(rubrique => {

			//click sur la div
			this.objCommons.bindEvent(rubrique.id, "click", (event) => {
				if (document.getElementById(event.currentTarget.id + "_lien").value !== "") {
					location.href = document.getElementById(event.currentTarget.id + "_lien").value;
				}
			});

			//s'il y a un bouton refresh
			this.objCommons.bindEvent(rubrique.id + "_refresh", "click", (event) => {
				const id = event.currentTarget.id.split("_");
				event.stopPropagation();
				objRubriques.refreshContent(id[1]);
			});

			//si c'est le rubrique forum
			if (rubrique.id === "rubrique_forum") {

				//boucle pour chaque sujet
				document.querySelectorAll(".sujet_rubrique_forum").forEach(sujet => {

					//action sur le click d'une colonne
					sujet.addEventListener("click", (event) => {
						event.stopPropagation();
						location.href = "../forum/sujet/" + event.currentTarget.getAttribute("name").split("_")[1];
					});
				});
			}

			//si c'est le rubrique items
			if (rubrique.id === "rubrique_items") {

				//boucle pour chaque auteurs
				document.querySelectorAll(".auteurs_rubrique_items").forEach(auteur => {

					//action sur le click d'une colonne
					auteur.addEventListener("click", (event) => {
						event.stopPropagation();
						this.objCommons.showAuteurs(event.currentTarget.id.split("_")[1]);
					});
				});
			}
		});

		//affichage des actu et des sujets tout les 10 secondes
		setInterval(() => objRubriques.switchDiv("sujets"), 5000);
	}
	/**
	 * Page avec les paramètres utilisateurs
	 */
	async utilisateurParametres() {

		//importe les modules
		const [{default: Connexion}, {default: Utilisateur}] = await Promise.all([
			import("./connexion"),
			import("./utilisateur")
		]);

		//register les classes
		this.appContext.register("objConnexion", new Connexion(this.appContext));
		this.appContext.register("objUtilisateur", new Utilisateur(this.appContext));

		//création des objets
		const objConnexion = this.appContext.get("objConnexion");
		const objUtilisateur = this.appContext.get("objUtilisateur");

		//valide la mise à jour des infos
		this.objCommons.bindEvent("valider", "click", () => objUtilisateur.updateInfos());

		//valide la mise à jour des infos
		this.objCommons.bindEvent("supprimer", "click", () => objUtilisateur.dialogDelete());

		//valide la mise à jour du pass
		this.objCommons.bindEvent("valider2", "click", () => objUtilisateur.updatePass());

		//estime la securite du mot de passe
		this.objCommons.bindEvent("pass", "keyup", () => objConnexion.evalPass());

		//affiche / cache le mot de passe
		objConnexion.togglePass();
	}
}
